import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterSingleDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template";
import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import { filterTagType_template } from "./filterTagType_template";
import { filterTag_template } from "./filterTag_template";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { filterAutocomplete_template } from "./filterAutocomplete_template";
import { imageWidget_template } from "./imageWidget_template";
import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import { videoPickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/videoPickerHelper";
import { Tag, dataType, specification } from "../../utils/types/tag";
import { vignettePreview_template } from "./vignettePreview_template";
import {
    SPEC_TYPE_MAP,
    SPEC_DATA_TYPES,
    SPEC_TYPE_DATE,
    SPEC_TYPE_IDS_NUMERIC,
    SPEC_TYPE_IDS_WITH_RESTRICTIONS,
    SPEC_TYPE_RATING,
    SPEC_TYPE_RICH_TEXT,
    SPEC_TYPE_TAG,
    SPEC_TYPE_TAGS,
    SPEC_TYPE_TEXT,
    SPEC_TYPE_LIST_TAG,
    isSpecTypeIdWithRestrictions,
    isSpecTypeIdPlainTextEntry,
    isSpecTypeIdImagesEntry,
    isSpecTypeIdListTag,
    SPEC_TYPE_IMAGES,
} from "../../utils/consts/tag_spec_type";
import { streamRentBuyFilter } from "../../utils/AffiliateLinkHelper";
import { getBrandInfoFromVnAppZone } from "../../utils/BrandHelper";
import { emaki_brand } from "../../utils/types/emaki_brand";
import { userCanEditOwnedTagType } from "../../utils/PermissionsHelper";
import TagDefaultsHelper from "../../utils/TagDefaultsHelper";
import videoPicker_template from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/videoPicker_template";
import { DragAndDropHandler } from "../../utils/DragAndDropHandler";
import LocaleHandler from "../../utils/LocaleHandler";
import { Locale } from "../../utils/types/locale";

declare let CKEDITOR: any;
declare let ko: any;

export class tagsEdit_template extends vnTemplate {
  //protected datePicker: filterSingleDate_template;
  public imagePicker: imagePicker_template;
  protected tagTypeFilter: filterTagType_template;
  public restrictionFilter: filterAutocomplete_template;
  protected tagFilter: filterTag_template;
  protected defaultTagFilter: filterTag_template;
  protected activeTagsEditPageTooltip: infoButton_template;
  protected activeTagsEditPageTooltipContent;
  protected selectableTagsEditPageTooltip: infoButton_template;
  protected selectableTagsEditPageTooltipContent;
  protected seoDescriptionTooltip: infoButton_template;
  protected seoDescriptionTooltipContent;
  protected editSpecificationTooltip: infoButton_template;
  protected editSpecificationTooltipContent;
  protected automaticPricingTooltip: infoButton_template;
  protected automaticPricingTooltipContent;
  public filterAffiliates: filterAutocomplete_template;
  public filterLocales: filterAutocomplete_template;
  public linkExpirationDatePicker: filterSingleDate_template;
  public imageWidgetForBrandTagImage: imageWidget_template;
  public imageWidgetForTagIconImage: imageWidget_template;
  public imageWidgetForTagBannerImage: imageWidget_template;
  public imageWidgetForBrandTagImageGroup: imageWidget_template;
  public imageWidgetForDefaultBrandTagImage: imageWidget_template;
  public imageWidgetForDefaultTagIconImage: imageWidget_template;
  public imageWidgetForDefaultTagBannerImage: imageWidget_template;
  public imageWidgetForDefaultBrandTagImageGroup: imageWidget_template;
  public imageWidgetForTagImagesSpecField: imageWidget_template;
  public tagVideoPicker: videoPicker_template;
  public imagePickerHelper: imagePickerHelper;
  public videoPickerHelper: videoPickerHelper;
  public vignetteFilter: filterAutocomplete_template;
  protected vignettePreview: vignettePreview_template;
  public defaultVignetteFilter: filterAutocomplete_template;
  protected defaultVignettePreview: vignettePreview_template;
  public reviewScoreEmbargoEndDate : filterSingleDate_template;
  protected localeHandler: LocaleHandler;
  protected idBrand: number;
  protected locales: Locale[] = [];

  protected getTemplateHtml(): string {
    return /* html */ `
           <div class="form-header">
                <h3 class="form-title" data-bind="if: id() == null">Add Tag</h3>
                <h3 class="form-title" data-bind="visible: id() != null, text: 'Edit Tag : ' + name()"></h3>
                <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
           </div>

           <div class="w-form-body">
                <div class="form-body">
                    <strong class="form-sub-title">Tag</strong>
                    <div class="form-group" data-bind="if: idBrand">
                        <div class="multi-row">
                            <input id="isTagActive" type="checkbox" data-bind="checked: isTagActive"/>
                            <label for="isTagActive" class="form-label icon i-check">Is Active</label>
                            <div class="w-tooltips-adv pos-bottom x-short" style="transform: translateY(8px);z-index: 300">
                                ${this.activeTagsEditPageTooltip.getHtmlBuild()}
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="multi-row" data-bind="if: idBrand">
                            <input id="isTagSelectable" type="checkbox" data-bind="enable: isTagActive, checked: isTagSelectable"/>
                            <label for="isTagSelectable" class="form-label icon i-check">Available for use </label>
                            <div class="w-tooltips-adv pos-bottom short" style="transform: translateY(8px);z-index: 299">
                                ${this.selectableTagsEditPageTooltip.getHtmlBuild()}
                            </div>
                        </div>
                        <!-- ko if: isBrandOwner() || (!idBrand() && brandOwner()) -->
                        <div class="multi-row brand-indicator" style="margin-top:2rem;">
                            <span data-bind="attr: { class: brandOwner().iconImage + ' dark square-icon brand-owner' }"></span>
                            <div class="" data-bind="text: getBrandOwnerInfoText()"></div>
                        </div>
                        <!-- /ko -->
                    </div>

                    <div class="form-group">
                        <label class="form-label">Name</label>
                        <div class="w-input">
                            <input type="text" name="name" id="name"  class="input-text" data-bind="value: name, enable: !idBrand() && permissions()['tag_edit'].write">
                        </div>
                    </div>

                    <!-- ko if: referenceDescription() -->
                    <div class="form-group">
                        <label class="form-label">Reference Description</label>
                        <div class="w-input">
                            <input type="text" name="referenceDescription" id="referenceDescription"  class="input-text" data-bind="value: referenceDescription" disabled>
                        </div>
                    </div>
                    <!-- /ko -->

                    <div class="form-group">
                        <label class="form-label">Owner Backlink Page URL</label>
                        <input type="text" name="name" id="name"  class="input-text" data-bind="value: urlHubPage, enable: (isBrandOwner() || (!idBrand() && brandOwner())) && permissions()['tag_edit'].write">
                    </div>

                    <div class="form-group">
                        <label class="form-label">Tag Type</label>
                        ${this.tagTypeFilter.getHtmlBuild()}

                    </div>

                    <strong class="form-sub-title">Tag Color</strong>
                    <div class="form-group">
                        <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                        <!-- ko ifnot: automaticDefault() -->
                            ${TagDefaultsHelper.getUseTagDefaultHtml(
                              "tagColor"
                            )}
                        <!-- /ko -->
                        <label class="form-label" style="margin-bottom: 0;">Tag Color</label>
                        </div>
                        <div class="w-input" style="display:flex; gap:.5rem; align-items: center;">
                            <!-- ko if: automaticDefault() -->
                                <input type="text"
                                    name="tagDefaultColor"
                                    id="tagDefaultColor"
                                    class="input-text"
                                    data-bind="
                                        value: tagDefaultColor,
                                        enable: permissions()['tag_color']?.write,
                                        valueUpdate: 'afterkeydown'
                                    "
                                >
                                <div data-bind="style: { 'background-color': tagDefaultColor() }"
                                    style="
                                        height: calc(3rem - 2px);
                                        width: calc(3rem - 2px);
                                        border: 1px solid #d1d1d1;
                                        border-radius: 10%; display:
                                        inline-block;
                                        margin-left: 5px;
                                    "
                                ></div>
                            <!-- /ko -->
                            <!-- ko if: !automaticDefault() && !useTagDefaults().tagColor -->
                                <input type="text" name="tagColor" id="tagColor"  class="input-text" data-bind="value: tagColor, enable: permissions()['tag_color']?.write, valueUpdate: 'afterkeydown'">
                                <div data-bind="style: { 'background-color': tagColor() }" style="height: calc(3rem - 2px);
                                    width: calc(3rem - 2px);
                                    border: 1px solid #d1d1d1;
                                    border-radius: 10%; display:
                                    inline-block;
                                    margin-left: 5px;"></div>
                            <!-- /ko -->
                        </div>
                    </div>

                    <strong class="form-sub-title">Image</strong>
                    <div class="form-group" style="margin-top: 1rem" >
                        <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                        <!-- ko ifnot: automaticDefault() -->
                            ${TagDefaultsHelper.getUseTagDefaultHtml("image")}
                        <!-- /ko -->
                        <label class="form-label" style="margin-bottom: 0;">Tag Image</label>
                        </div>
                    </div>
                    
                        <div class="form-group img">
                            ${this.imageWidgetForDefaultBrandTagImage.getHtmlBuild()}
                        </div>
                    <!-- ko ifnot: automaticDefault() -->
                        <div class="form-group img" data-bind="if: !useTagDefaults().image ">
                            ${this.imageWidgetForBrandTagImage.getHtmlBuild()}
                        </div>
                    <!-- /ko -->


                    <strong class="form-sub-title">Icon</strong>
                    <div class="form-group" style="margin-top: 1rem"  >
                        <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                        <!-- ko ifnot: automaticDefault() -->
                            ${TagDefaultsHelper.getUseTagDefaultHtml(
                              "iconImage"
                            )}
                        <!-- /ko -->
                        <label class="form-label" style="margin-bottom: 0;">Icon</label>
                        </div>
                    </div>
                    <!-- ko if: automaticDefault() -->
                        <div class="form-group img">
                            ${this.imageWidgetForDefaultTagIconImage.getHtmlBuild()}
                        </div>
                    <!-- /ko -->
                    <!-- ko ifnot: automaticDefault() -->
                        <div class="form-group img" data-bind="if: !useTagDefaults().iconImage ">
                            ${this.imageWidgetForTagIconImage.getHtmlBuild()}
                        </div>
                    <!-- /ko -->

                    <strong class="form-sub-title">Banner</strong>
                    <div class="form-group" style="margin-top: 1rem"  >
                        <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                        <!-- ko ifnot: automaticDefault() -->
                            ${TagDefaultsHelper.getUseTagDefaultHtml(
                              "bannerImage"
                            )}
                        <!-- /ko -->
                        <label class="form-label" style="margin-bottom: 0;">Banner Image</label>
                        </div>
                    </div>
                    <!-- ko if: automaticDefault() -->
                        <div class="form-group img">
                            ${this.imageWidgetForDefaultTagBannerImage.getHtmlBuild()}
                        </div>
                    <!-- /ko -->
                    <!-- ko ifnot: automaticDefault() -->
                        <div class="form-group img" data-bind="if: !useTagDefaults().bannerImage ">
                            ${this.imageWidgetForTagBannerImage.getHtmlBuild()}
                        </div>
                    <!-- /ko -->


                    <strong class="form-sub-title">Image Group</strong>
                    <div class="form-group" style="margin-top: 1rem" >
                        <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                        <!-- ko ifnot: automaticDefault() -->
                            ${TagDefaultsHelper.getUseTagDefaultHtml(
                              "imageGroup"
                            )}
                        <!-- /ko -->
                        <label class="form-label" style="margin-bottom: 0;">Tag Image Group</label>
                        </div>
                    </div>
                    <!-- ko if: automaticDefault() -->
                        <div class="form-group img-group">
                        ${this.imageWidgetForDefaultBrandTagImageGroup.getHtmlBuild()}
                        </div>
                    <!-- /ko -->
                    <!-- ko ifnot: automaticDefault() -->
                        <div class="form-group img-group" data-bind="if: !useTagDefaults().imageGroup ">
                        </div>
                    <!-- /ko -->
                    <!-- ko ifnot: automaticDefault() -->
                        <div class="form-group img-group" data-bind="if: !useTagDefaults().imageGroup ">
                            ${this.imageWidgetForBrandTagImageGroup.getHtmlBuild()}
                        </div>
                    <!-- /ko -->
                    <!-- ko if: idBrand -->
                        <strong class="form-sub-title">Tag Video</strong>
                        <div class="form-group row" style="margin-bottom: .5rem;" >
                            <label class="form-label">Tag Video</label>
                        </div>
                        <div class="form-group img-group tag-video">
                            <button class="btn-form icon i-video-2" type="button" data-bind="event: { click: onClickSelectVideo }">Select Video</button>
                            <!-- ko if: tagVideo -->
                                <button class="btn-form icon i-video" data-bind="event: { click: onClickWatchVideo }">Watch Video</button>
                                <button class="btn-form icon i-delete" data-bind="event: { click: onClickRemoveVideo }"></button>
                                <span data-bind="text: tagVideoTitle"></span>
                                <div class="icon-img icon i-video-2 ">
                                    <img data-bind="attr: { src: tagVideoThumbnailURL, alt: tagVideoTitle }" />
                                </div>
                            <!-- /ko -->
                        </div>
                    <!-- /ko -->
                </div>

                <div class="form-body">

                    <strong class="form-sub-title">SEO Description</strong>

                    <div class="form-group seo-description">

                        <div class="d-flex" style="align-items: center; flex-wrap: wrap; gap:4px;">
                            <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                            <label style="margin-bottom: 0" class="form-label">SEO Description</label>
                            <div class="w-tooltips-adv pos-right short" style="transform: translateY(8px);z-index: 300">
                                ${this.seoDescriptionTooltip.getHtmlBuild()}
                            </div>
                            </div>
                        </div>
                        <!-- ko if: automaticDefault() -->
                            <textarea rows="3" data-bind=" value: tagDefaults().shortDescription" /></textarea>
                        <!-- /ko -->
                        <!-- ko if: !automaticDefault() && !useTagDefaults().shortDescription -->
                            <textarea rows="3" data-bind=" value: seoDescription" /></textarea>
                        <!-- /ko -->
                    </div>

                    <!-- ko if: idBrand -->
                    <strong class="form-sub-title">Review Score</strong>

                    <div class="form-group seo-description">
                        <!-- ko if: embargoPermissions().write || ( !embargoPermissions().write && !reviewScoreIsUnderEmbargo() ) -->
                        <div class="d-flex" style="align-items: center">
                            <label style="margin-bottom: 0" class="form-label">Review Score</label>
                        </div>
 
                        <input type="number" step="0.1" min="0.1" max="10" placeholder="X.X" data-bind="value: reviewScore">
                        <button class="btn-form" type="button" data-bind="visible: showAutoCalculateReviewScore, event: { click: onClickAutoCalculateReviewScore }">Auto-calculate</button>
                        <!-- /ko -->

                        <!-- ko if: !embargoPermissions().write && reviewScoreIsUnderEmbargo() -->
                        <div class="d-flex" style="align-items: center">
                            <label style="margin-bottom: 0" class="form-label">Review Score</label>
                        </div>
                        <div data-bind="text : 'Score Under Embargo Until ' + reviewScoreEmbargoEndDate.singleDatePicker()" ></div>
                        <!-- /ko -->

                        <!-- ko if: embargoPermissions().write -->
                        <div class="form-group form-check-inline" style="margin: 2rem 2rem">
                            <input type="checkbox" data-bind="checked: reviewScoreIsUnderEmbargo, event : { change : onChangeSetReviewScoreEmbargoEndDate  }" id="review_score_under_embargo">
                            <label for="review_score_under_embargo" class="form-label icon i-check" style="line-height: 1.3;">Review Score Under Embargo</label>
                        </div>

                        <div data-bind="hidden: !reviewScoreIsUnderEmbargo()">
                            <div class="d-flex" style="align-items: center; margin-top: 2rem" >
                                <label class="form-label" >Review Score Under Embargo End Date</label>
                            </div>
                            ${this.reviewScoreEmbargoEndDate.getHtmlBuild()}
                        </div>
                        <!-- /ko -->
                    </div>
                    <!-- /ko -->

                    <strong class="form-sub-title">Links</strong>

                    <div class="tag-header-right-row affiliate-link">
                        <div class="form-group" class="d-flex" style="align-items: center;border: 0;">
                            <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                            <!-- ko ifnot: automaticDefault() -->
                                ${TagDefaultsHelper.getUseTagDefaultHtml(
                                  "affiliateLinks"
                                )}
                            <!-- /ko -->
                            <label class="form-label" style="margin: 0">Links</label>
                            <!-- ko if: idBrand() && (automaticDefault() || !useTagDefaults().affiliateLinks) -->
                                <button class="btn-form icon icon-only i-plus " type="button" data-bind="event: { click: onClickShowAffiliateLink }"></button>
                            <!-- /ko -->
                            </div>
                        </div>
                    </div>

                    <div class="tag-header-right-row affiliate-link">
                        <!-- id="affiliate_links_section" -->
                        <div class="form-group affiliate-list">
                            <!-- ko if: automaticDefault() || affiliateLinks === null -->
                                <!-- ko foreach: tagDefaults().affiliateLinks -->
                                  ${this.getAffiliateLinksHtml()}
                                <!-- /ko -->
                            <!-- /ko -->
                            <!-- ko ifnot: (automaticDefault() || affiliateLinks === null) -->
                                <!-- ko if: !useTagDefaults().affiliateLinks -->
                                    <!-- ko foreach: affiliateLinks -->
                                      ${this.getAffiliateLinksHtml()}
                                    <!-- /ko -->
                                <!-- /ko -->
                            <!-- /ko -->
                        </div>
                    </div>

                  <!-- ko if: idBrand() && (automaticDefault() || !useTagDefaults().affiliateLinks) -->
                    <strong class="form-sub-title">Advanced Option Links</strong>

                    <div class="tag-header-right-row affiliate-link">
                        <div class="form-group" class="d-flex" style="align-items: center;border: 0;">
                            <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                            <label class="form-label" style="margin: 0">Advanced Links</label>
                            <!-- ko if: idBrand() && (automaticDefault() || !useTagDefaults().affiliateLinks) -->
                                <button class="btn-form icon icon-only i-plus " type="button" data-bind="event: { click: onClickShowAffiliateOptionLink }"></button>
                            <!-- /ko -->
                            </div>
                        </div>
                    </div>

                    <div class="tag-header-right-row affiliate-link">
                        <!-- id="affiliate_option_links_section" -->
                        <div class="form-group affiliate-list">
                            <div class="">
                              ${this.getAffiliateLinkOptionsHtml()}
                            </div>
                            <div class="affiliate-options-list">
                            <!-- ko if: automaticDefault() || (affiliateLinks() === null || affiliateLinks().length <= 0) -->
                                <!-- ko foreach: affiliateOptionLinks -->
                                    ${this.getAffiliateOptionsLinksHtml()}
                                <!-- /ko -->
                            <!-- /ko -->
                            <!-- ko ifnot: (automaticDefault() || (affiliateLinks() === null || affiliateLinks().length <= 0)) -->
                                <!-- ko if: !useTagDefaults().affiliateLinks -->
                                    <!-- ko foreach: affiliateOptionLinks -->
                                        ${this.getAffiliateOptionsLinksHtml()}
                                    <!-- /ko -->
                                <!-- /ko -->
                            <!-- /ko -->
                            <!--<div data-bind="text: ko.toJSON(affiliateLinks(), null, 2)"></div>
                            <br><br><br>break here <br><br><br>
                            <div data-bind="text: ko.toJSON(tagDefaults().affiliateLinks, null, 2)"></div>-->
                            </div>
                        </div>
                    </div>
                  <!-- /ko -->

                    <strong class="form-sub-title">Description</strong>
                    <div class="form-group">
                        <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                            <label style="margin-bottom: 0" class="form-label">Description</label>
                        </div>
                    </div>
                    <div class="form-group form-group-textarea">
                        <!-- ko if: automaticDefault() -->
                            <textarea id="product_review_text" data-bind=" value: tagDefaults().description" ></textarea>
                        <!-- /ko -->
                        <!-- ko ifnot: automaticDefault() -->
                            <textarea id="product_review_text"
                                data-bind="
                                    value: reviewText,
                                    visible: !useTagDefaults().description
                                "
                            ></textarea>
                        <!-- /ko -->
                    </div>
                </div>
            </div>
            <div class="w-form-body">
                <strong class="form-sub-title">Vignette</strong>
                <div class="form-group">
                    <label style="margin-bottom: 0" class="form-label">Vignette</label>
                    <!-- ko ifnot: automaticDefault() -->
                        ${TagDefaultsHelper.getUseTagDefaultHtml("vignette")}
                    <!-- /ko -->
                </div>
                <div class="form-body full-width">
                    <!-- ko if: automaticDefault() -->
                        <div class="form-group">
                            <!-- ko if: permissions()['vignettes'].write -->
                                <div class="form-group vignette">
                                    ${this.defaultVignetteFilter.getHtmlBuild()}
                                </div>
                                <hr>
                            <!-- /ko -->
                        </div>
                        <div class="form-group row" data-bind="visible: idSelectedDefaultVignette() != null">
                            ${this.defaultVignettePreview.getHtmlBuild()}
                        </div>
                        <div class="form-group row" data-bind="visible: idSelectedDefaultVignette() == null">
                            None
                        </div>
                    <!-- /ko -->
                    <!-- ko if: !automaticDefault() && !useTagDefaults().vignette-->

                        <div class="form-group">
                            <!-- ko if: permissions()['vignettes'].write -->
                                <div class="form-group vignette">
                                    ${this.vignetteFilter.getHtmlBuild()}
                                </div>
                                <hr>
                            <!-- /ko -->
                        </div>
                        <div class="form-group row" data-bind="visible: idSelectedVignette() != null">
                            ${this.vignettePreview.getHtmlBuild()}
                        </div>
                        <div class="form-group row" data-bind="visible: idSelectedVignette() == null">
                            None
                        </div>
                    <!-- /ko -->
                </div>
            </div>

        <!-- ko if: providers().length > 0 && isBrandOwner() || (!idBrand() && brandOwner()) -->
            <div class="w-form-body">
                <div class="form-body full-width">
                    <strong class="form-sub-title">Providers</strong>
                    <!-- ko foreach: providers -->
                        <div class="form-group">
                            <div class="d-flex align-center" style="align-items: center; flex-wrap: wrap; gap: 4px;">
                                <div class="d-inline-flex align-center" style="flex-wrap:wrap;">
                                    <label data-bind="text: providerName" class="form-label"></label>
                                        <!-- ko if: $data.infoButton -->
                                        <div class="w-tooltips-adv short pos-right" data-bind="template: { name: 'infoButton-template', data: $data.infoButton.getTemplateViewModel() }" style="transform: translateY(8px);z-index: 300"></div>
                                        <!-- /ko -->
                                 </div>
                                <input type="text" data-bind="value: idProviderReference, valueUpdate: 'afterkeydown'" class="input-text" />
                                  <!-- ko if: providerName === 'Watchmode' && $parent.idBrand() -->
                                  <div class="form-check-inline" style="margin-left: 1rem;">
                                      <input id="pullWatchmodeData" type="checkbox" data-bind="checked: $parent.pullWatchmodeData">
                                      <label for="pullWatchmodeData" class="form-label icon i-check">Pull New Data from Watchmode</label>
                                  </div>
                                   <!-- /ko -->
                            </div>
                        </div>
                    <!-- /ko -->
                </div>
           </div>
        <!-- /ko -->

            <div class="w-form-body" style="margin-top: -1.25rem">
                <div class="form-body full-width  no-border" style="position: relative;">
                    <strong class="form-sub-title">Specifications</strong>
                    <!-- ko if: canEditThisTag() -->
                        <button id="add_specification" class="form-section-btn icon i-plus" data-bind="event: {click: onClickAddSpecification}, visible: !idBrand() && tagType" type="button"></button>
                        <button id="set_all_to_default" class="form-section-btn default-tag-btn only-icon icon i-circle" data-bind="event: {click: onClickSetAllSpecificationsToDefault}, visible: idBrand() && tagType" type="button">Set All to Use Default</button>
                    <!-- /ko -->
               </div>
            </div>
            <div class="w-form-body">
                <div class="form-body full-width">
                    <div id="spec_section" class="form-group  specification">
                        <table id="spec_section_list" class="list-action full-width" >
                            <thead>
                                <tr style="background-color: #8a8a8a"> 
                                    <th>
                                        <span>Field Name</span>
                                    </th>
                                     <th>
                                        <span>Type</span>
                                    </th>
                                    <th data-bind="visible: permissions()['vignettes'].read">
                                        <span>Reference</span>
                                    </th>
                                    <!-- ko if: idBrand -->
                                    <th>
                                        <span>Value</span>
                                    </th>
                                    <!-- /ko -->
                                    <!-- ko ifnot: idBrand -->
                                    <th>
                                        <span>Default</span>
                                    </th>
                                    <!-- /ko -->
                                    <!-- ko if: canEditThisTag() -->
                                    <th style="width: 10rem;">
                                       <span>Action</span>
                                    </th>
                                    <!-- /ko -->
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: { data: specifications, as: 'spec' }">
                                <tr data-bind="css: { 'third-party-spec' : spec.isProvider }">
                                    <td>
                                        <span data-bind="
                                            html: $parent.getSpecLabel(spec),
                                            enable: isAdded,
                                            css: {
                                                'read-only': !isAdded || fieldId != null,
                                                'default-value': spec.isDefault,
                                                'icon i-cloud': spec.isProvider,
                                            }
                                        "></span>
                                    </td>
                                    <td>
                                        <span data-bind="text: dataType, enable: isAdded, css: {'read-only': !isAdded || fieldId != null}">
                                    </td>
                                    <td class="align-center" data-bind="visible: $parent.permissions()['vignettes'].read">
                                        <span data-bind="text: $data.reference ? '[[' + reference + ']]' : ''"></span>
                                    </td>
                                    <!-- ko if: $parent.idBrand() && !isDefault -->
                                        <td class="d-flex">
                                            <div class="only-icon icon i-circle"></div>
                                            <div data-bind="if: dataType == 'text' || dataType == 'date' || dataType == 'rich text' || dataType == 'currency' || dataType == 'number' || dataType == 'rating'">
                                                <span data-bind="html: value"></span>
                                            </div>
                                             
                                            <!-- ko if: $data.dataType == 'images' -->
                                            <div>
                                                <span data-bind="text: (value != null && Array.isArray(value) && value.length > 0) ? value.length + ' images in group' : ''"></span>
                                            </div>
                                            <!-- /ko -->
                                            <div data-bind="if: dataType == 'tag' || dataType == 'tags' || dataType == 'listtag'">
                                            <!-- ko if: value && value.length > 0 -->
                                                <ul  class="list-tag" data-bind="foreach: value">
                                                    <li class="item-tag">
                                                        <span class="form-tag" data-bind="text: name + (type != null ? ' (' + type.name + ')' : '')"></span>
                                                    </li>
                                                </ul>
                                            <!-- /ko -->
                                            </div>
                                        </td>
                                    <!-- /ko -->
                                    <!-- ko if: !$parent.idBrand() || isDefault -->
                                        <td class="default-value d-flex">
                                            <div class="only-icon icon i-circle"></div>
                                            <!-- ko if: ($data.dataType == 'tags' || $data.dataType == 'listtag') && $parent.getSpecDefault($data) -->
                                            <div>
                                                <ul class="list-tag" data-bind="foreach: {data: $parent.getSpecDefault($data), as: 'defVal' }">
                                                    <li class="item-tag">
                                                        <span class="form-tag" data-bind="text: defVal"></span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <!-- /ko -->

                                            <!-- ko ifnot: ($data.dataType == 'tags' || $data.dataType == 'listtag') && $parent.getSpecDefault($data) -->
                                            <div>
                                                <span data-bind="html: $parent.getSpecDefault($data, '[CURRENTLY EMPTY]')"></span>
                                            </div>
                                            <!-- /ko -->
                                        </td>
                                    <!-- /ko -->
                                    <!-- ko if: $parent.canEditThisTag() -->
                                        <td class="w-btn align-center">
                                            <!-- ko ifnot: $parent.isDataTypeJSON($data.dataType) || ($data.dataType == 'listtag' && $parent.idBrand() && !$parent.isBrandOwner()) -->
                                            <button type="button" class="btn-form icon icon-only i-edit" data-bind="event: {click: $parent.onClickEditSpecification.bind($index) }"></button>
                                            <!-- /ko -->
                                            <!-- ko if: $data.canDelete -->
                                                <button type="button" class="btn-form icon icon-only i-delete" data-bind="event: {click: $parent.onClickDeleteSpecification.bind($index) }"></button>
                                            <!-- /ko -->
                                        </td>
                                    <!-- /ko -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="form-footer">
                <button type="button" data-bind="event: { click: onClickCancel }" class="btn ">Cancel</button>
                <button type="button" data-bind="event: { click: onClickSave }" class="btn highlight">Save</button>
            </div>

            ${this.getSpecPopupHtml()}

            ${this.imagePicker.getHtmlBuild()}

            <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isAffiliateLinksFormShown }">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form" style="width:50rem;">
                        <div class="form-header">
                            <h3 class="form-title">Add Link</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: {click: onClickCancelAffiliateLink }" ></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group alert-message error" data-bind="visible: affiliateLinkError">
                              <i class="icon i-notice-alert"></i>
                              <span><strong>Error: </strong><span data-bind="text: affiliateLinkError"></span></span>
                            </div>
                            <div class="form-group">
                                ${this.filterAffiliates.getHtmlBuild()}
                            </div>
                            <div class="form-group row form-check-inline" data-bind="visible: isAutoLinkerEnabled">
                                <input id="autoAffiliateEmakiAutolinker" type="checkbox" data-bind="checked: autoAffiliateEmakiAutolinker">
                                <label for="autoAffiliateEmakiAutolinker" class="icon i-check">Auto-Affiliate With Emaki Autolinker</label>
                            </div>
                            <div class="form-group row form-check-inline" data-bind="visible: isAutoLinkerThirdPartyServiceEnabled">
                                <input id="autoAffiliateThirdPartyService" type="checkbox" data-bind="checked: autoAffiliateThirdPartyService">
                                <label for="autoAffiliateThirdPartyService" class="icon i-check">Auto-Affiliate With Third Party Affiliation Services</label>
                            </div>
                            <div class="form-group row form-check-inline" data-bind="visible: affiliateAutomaticPricingAvailable">
                                <input id="automatic-pricing" type="checkbox" data-bind="checked: affiliateAutomaticPricing">
                                <label for="automatic-pricing" class="icon i-check">automatic pricing</label>
                                <div class="w-tooltips-adv pos-right short" style="top: 0.9em;position: relative;">
                                        ${this.automaticPricingTooltip.getHtmlBuild()}
                                </div>
                            </div>

                            <div class="form-group row" data-bind="visible: !affiliateAutomaticPricingAvailable() || !affiliateAutomaticPricing()">
                                <label for="" class="form-label">sale price</label>
                                <input class="input-text number"  data-bind="value: affiliateSalePrice" type="number">
                            </div>
                            <div class="form-group row" data-bind="visible: !affiliateAutomaticPricingAvailable() || !affiliateAutomaticPricing()">
                                <label for="" class="form-label">full price</label>
                                <input class="input-text number"  data-bind="value: affiliatePrice" type="number">
                            </div>
                            <div class="form-group inside-label">
                                 <label for="" class="form-label">url</label>
                                 <input class="input-text"  data-bind="value: affiliateUrl" type="text">
                            </div>
                            <div class="form-group row">
                                 <label for="" class="form-label">expiration</label>
                                 <select name="" id="" data-bind="value: affiliateExpirationOption">
                                      <option value="1">None</option>
                                      <option value="2">Now</option>
                                      <option value="3">Scheduled</option>
                                 </select>
                            </div>
                            <div class="form-group" data-bind="visible: affiliateExpirationOption() == 3">
                                <!--<label for="" class="form-label">expiration</label>-->
                                 ${this.linkExpirationDatePicker.getHtmlBuild()}
                            </div>
                            <div class="form-group inside-label">
                                 <label for="" class="form-label">link text override</label>
                                 <input class="input-text"  data-bind="value: affiliateLinkTextOverride" type="text">
                            </div>
                            <div class="form-group inside-label" data-bind="visible: defaultsHaveStreamRentBuyLinks && isAffiliateLinksFormAdvancedVisible">
                              ${this.filterLocales.getHtmlBuild()}
                            </div>
                            <div class="form-group inside-label" data-bind="visible: defaultsHaveStreamRentBuyLinks && isAffiliateLinksFormAdvancedVisible">
                                 <label for="" class="form-label">Option</label>
                                 <input class="input-text" data-bind="value: option" type="text">
                            </div>
                        </div>

                        <div class="form-footer">
                            <button type="button" class="btn" data-bind="event: {click: onClickCancelAffiliateLink }">Cancel</button>
                            <button type="button" class="btn highlight icon i-check" data-bind="event: {click: onClickAddAffiliateLink }">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            ${this.tagVideoPicker.getHtmlBuild()}
            ${this.getInactiveTagPopupHtml()}
            `;
  }

  protected getAffiliateLinksHtml(): string {
    return /* html */ `
            <div class="form-row" data-bind="visible: (!$data.countryCode && !$data.option)">
                <label data-bind="text: type" class="form-label"></label>
                <div>
                    <div class="afilliate-price">
                        <span class="form-read" data-bind="text: !$data.automaticPricing && $data.salePrice ? '$' + salePrice : ''"> </span>
                        <span class="form-read" data-bind="text: !$data.automaticPricing && $data.price ? '$' + price : '', css: { 'regular-price' : $data.salePrice }"> </span>
                        <span class="form-read" data-bind="text: !$data.automaticPricing && $data.price &&  $data.salePrice ? 'Save $' + (Math.round((price - salePrice) * 100) / 100) : ''"> </span>
                        <span class="form-read" style="position:relative;left:-.75em;" data-bind="text: $data.automaticPricing ? 'Automatic Pricing' : ''"> </span>
                    </div>
                    <a target="_blank" data-bind="attr: { id : 'link-preview-' + $data.id, href : value}, text : value.substr(0,30)" id="site-view202761"></a>
                </div>
                <!-- ko if: $parent.idBrand() -->
                    <div class="d-flex">
                        <button class="btn-form icon icon-only i-edit" data-bind="event: { click: $parent.onClickEditLink }"><span class="hidden-text">edit</span></button>
                        <button class="btn-form icon icon-only i-cross" type="button" data-bind="event: { click: $parent.onClickDeleteLink }"><span class="hidden-text">delete</span></button>
                    </div>
                <!-- /ko -->
            </div>
            <!--<div data-bind="text: ko.toJSON($data, null, 2)"></div>-->
        `;
  }

  protected getAffiliateOptionsLinksHtml(): string {
    return /* html */ `

      <!-- ko ifnot: $data.option === null || $data.option === ""-->
      <div class="form-row" data-bind="visible: $data.option">
        <label data-bind="text: $data.type" class="form-label"></label>
        <div>
          <span class="form-read"><a target="_blank" data-bind="attr: { id : 'link-preview-' + $data.id, href : value}, text : value.substr(0,30)" id="site-view202761"></a></span>
          <span class="form-read" data-bind="text: $data.option ? $data.option : ''"> </span>
          <span class="form-read" data-bind="text: $data.countryCode ? $data.countryCode : ''"> </span>
        </div>
        <!-- ko if: $parent.idBrand() -->
            <div class="d-flex">
                <button class="btn-form icon icon-only i-edit" data-bind="event: { click: $parent.onClickEditOptionsLink }"><span class="hidden-text">edit</span></button>
                <button class="btn-form icon icon-only i-cross" type="button" data-bind="event: { click: $parent.onClickDeleteLink }"><span class="hidden-text">delete</span></button>
            </div>
        <!-- /ko -->
      </div>
      <!-- /ko -->
      <!--<div data-bind="text: ko.toJSON($data, null, 2)"></div>-->
    `;
  }

  protected getAffiliateLinkOptionsHtml(): string {
    return /* html */ `
      <label class="form-label" data-bind="html: affiliateOptionsString"></label>
    `;
  }

  protected getSpecPopupHtml(): string {
    return /* html */ `
            <div data-bind="css: { 'is-visible': isAddSpecVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form" style="width:40rem;">
                        <div class="form-header">
                            <h3 class="form-title" data-bind="text: popupTitle"></h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCancelSaveSpecification }"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group row">
                            <!-- ko if: providerName -->
                            <div class="d-flex" style="margin: 0;padding: 1rem;border: 1px solid #cacaca;background: #f5f5f5;border-radius: 4px;gap: 0.4rem">
                              <label class="icon i-cloud"></label>
                              <p class="form-text"> 
                                This spec data is provided for by <b data-bind="text: providerName"></b>.  If you change the value, it may be overwritten the next time the provider sends an update.
                              </p>
                            </div>                          
                            <!-- /ko -->

                            </div>                          
                            <div class="form-group row">
                                <label class="form-label">Label</label>
                                <input type="text" class="input-text"  data-bind="value: specificationLabel, enable: !idBrand() && (permissions()['tag_type_field_label_edit'].write || permissions()['tag_type_field_label_edit'].update)">
                            </div>


                            <div class="form-group row">
                                <label class="form-label">Type</label>
                                <select id="" class="full-width" data-bind="options: specTypes_options, disable: idField(), optionsCaption: 'Choose an option', optionsText: 'name', value: selectedSpecType, optionsValue: 'id', event: { change: onChangeSpecificationType }"></select>
                            </div>
                            <div class="form-group" data-bind="visible: showTagSpecDetails(), css: { 'is-disable' : idBrand() && !(permissions()['tag_type_field_label_edit'].write || permissions()['tag_type_field_label_edit'].update) }" >
                                ${this.restrictionFilter.getHtmlBuild()}
                                <div class="form-group row" data-bind="foreach: oldRestrictionTypeArray, css: { 'is-disable' : idField() }" style="top: -1rem;">
                                    <div class="btn-selection"><span data-bind="text: name + ' ' + formattedDataset"></span></div>
                                </div>
                                <div class="form-group row" data-bind="foreach: restrictionTypeArray" style="margin-top: -2rem">
                                    <div class="btn-selection"><span data-bind="text: name"></span><button class="icon i-x-after" type="button" data-bind="event: { click: $parent.onClickDeleteRestrictionTypeArray }"></button></div>
                                </div>
                            </div>


                            <!-- ko if: idBrand() -->
                                <!-- ko if: isBrandOwner() -->
                                ${this.getDefaultValueHtml()}
                                <!-- /ko -->
                                ${this.getValueHtml()}
                                <!-- ko if: !isBrandOwner() -->
                                ${this.getUseDefaultHtml()}
                                <!-- /ko -->
                            <!-- /ko -->

                            <!-- ko ifnot: idBrand() -->
                            ${this.getDefaultValueHtml()}
                            <!-- /ko -->

                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCancelSaveSpecification }" class="btn ">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickSaveSpecification }, enable: ( selectedSpecType() && specificationLabel() &&  ( (selectedSpecType() != 2 && selectedSpecType() != 3 && selectedSpecType() != 10) || selectedSpecType() == 10 || restrictionTypeArray().length > 0 || oldRestrictionTypeArray().length) ) " class="btn highlight">Apply</button>
                        </div>

                    </div>
                </div>
            </div>
            `;
  }

  protected getValueLabelHtml(label: string): string {
    return /* html */ `
            <!-- ko if: isBrandOwner() -->
                <input id="add-override" type="checkbox" data-bind="checked: useOverride" />
                <label for="add-override" class="form-label icon i-check" data-bind="text: brand().shortName + ' Only'"></label>
            <!-- /ko -->
            <!-- ko ifnot: isBrandOwner() -->
                <label class="form-label">${label}</label>
            <!-- /ko -->
            `;
  }

  protected getValueHtml(): string {
    return /* html */ `
            <div data-bind="visible: selectedSpecType() == 8">
                <div class="form-group row">
                    ${this.getValueLabelHtml("Value")}
                </div>
                <!-- ko if: (!isBrandOwner() && !useDefault()) || useOverride() -->
                <div class="form-group row">
                    <label class="form-label">Rating</label>
                    <div class="form-detail">
                        <input class="input-text" type="number" data-bind="value: specificationData" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="form-label">Rating Scale</label>
                    <div class="form-detail">
                        <input class="input-text" type="number" data-bind="value: ratingScale" />
                    </div>
                </div>
                <!-- /ko -->
            </div>

            <div class="form-group" data-bind="visible: showPlainTextField()">
                ${this.getValueLabelHtml("Value")}
                <!-- ko if: (!isBrandOwner() && !useDefault()) || useOverride() -->
                <textarea class="input-text textarea" data-bind="value: specificationData"></textarea>
                <!-- /ko -->
            </div>
            <div  class="form-group" data-bind="visible: selectedSpecType() == 5">
                ${this.getValueLabelHtml("Value")}
                <!-- ko if: (!isBrandOwner() && !useDefault()) || useOverride() -->
                <textarea id="tagsEditTextArea" class="input-text textarea" data-bind="value: specificationData"></textarea>
                <!-- /ko -->
            </div>

            <div class="form-group" data-bind="visible: showTagSpecDetails()">
                <div class="d-flex">
                    <!-- ko if: selectedSpecType() == 2 -->
                    ${this.getValueLabelHtml("Tag")}
                    <!-- /ko -->
                    <!-- ko if: selectedSpecType() == 3 -->
                    ${this.getValueLabelHtml("Tags")}
                    <!-- /ko -->
                    <!-- ko ifnot: isBrandOwner() -->
                    <div class="w-tooltips-adv pos-top short" >
                        ${this.editSpecificationTooltip.getHtmlBuild()}
                    </div>
                    <!-- /ko -->
                </div>

                <!-- ko if: (!isBrandOwner() && !useDefault()) || useOverride() -->
                ${this.tagFilter.getHtmlBuild()}

                <div class="d-flex"
                    style="flex-wrap: wrap;"
                    data-bind="
                        visible: selectedSpecType() == 3,
                        foreach: editedSelectedTags,
                        childrenComplete: handleDragAndDrop($element, editedSelectedTags, '.sortable')
                    "
                >
                    <div class="sortable" style="background: #eaeaea; width:100%;">
                        <div class="btn-f-s"
                            style="
                                background-color:#eaeaea;
                                color:#000000;
                                justify-content:space-between;
                                display:flex;
                                align-items:center;
                                padding-top:0;
                                padding-right:0;
                                margin-bottom:0!important;
                                line-height:2.0rem;
                                height:2.0rem;
                                overflow:hidden;
                                width:100%;
                            "
                        >
                            <div class="d-inline-flex" style="gap:0.5rem;">
                                <span class="icon i-drag"></span>
                                <span data-bind="text: $data.name + ($data.type != null ? ' (' + $data.type.name + ')' : '')"></span>
                            </div>
                            <button class="btn-f-s icon i-x-after"
                                data-bind="event: {click: $parent.onClickRemoveSelectedTag }"
                                style="
                                    border-top-left-radius:0;
                                    border-bottom-left-radius:0;
                                    margin-right:0!important;
                                    margin-bottom:0!important;
                                    cursor:pointer;
                                    line-height:1.7rem;
                                    height:3rem;
                                    font-size:2rem;
                                    color:#000;
                                "
                            ></button>
                        </div>
                    </div>
                </div>
                <!-- /ko -->
            </div>
            <div class="form-group row"  data-bind="visible: selectedSpecType() == 4">
                ${this.getValueLabelHtml("Date")}
                <!-- ko if: (!isBrandOwner() && !useDefault()) || useOverride() -->
                <input type="text" class="input-text"  data-bind="value: dateSpec" placeholder="YYYY-MM-DD">
                <!-- /ko -->
            </div>
            <div data-bind="visible: idBrand() && selectedSpecType() == 9" class="form-group img-group">
                ${this.getValueLabelHtml("Images")}
                ${this.imageWidgetForTagImagesSpecField.getHtmlBuild()}
            </div>
        `;
  }

  protected getUseDefaultHtml(): string {
    return /* html */ `
            <div class="form-group row default-value">
                <label style="margin: 0;" class="form-label" for="use-default">Use Default</label>
                <div class="form-detail">
                    <input type="checkbox" id="use-default" data-bind="checked: useDefault">
                    <label class="icon i-check" for="use-default">
                        <!-- ko if: idField() && selectedSpecType()-->
                        <div data-bind="html: getSpecDefaultAtIdField()"></div>
                        <!-- /ko -->
                        <!-- ko ifnot: idField() && selectedSpecType()-->
                        <div data-bind="text: '[CURRENTLY EMPTY]'"></div>
                        <!-- /ko -->
                    </label>
                </div>
            </div>
        `;
  }

  protected getDefaultLabelHtml(): string {
    return /* html */ `
            <label class="form-label">Network Default</label>
        `;
  }

  protected getDefaultValueHtml(): string {
    return /* html */ `
            <div data-bind="visible: selectedSpecType() == 8" class="default-value">
                <div class="form-group row">
                    ${this.getDefaultLabelHtml()}
                </div>
                <div class="form-group row">
                    <label class="form-label">Rating</label>
                    <div class="form-detail">
                        <input class="input-text" type="number" data-bind="value: specificationDefault" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="form-label">Rating Scale</label>
                    <div class="form-detail">
                        <input class="input-text" type="number" data-bind="value: defaultRatingScale" />
                    </div>
                </div>
            </div>

            <div class="form-group default-value" data-bind="visible: showPlainTextField()">
                ${this.getDefaultLabelHtml()}
                <textarea class="input-text textarea" data-bind="value: specificationDefault"></textarea>
            </div>
            <div class="form-group default-value" data-bind="visible: selectedSpecType() == 5">
                ${this.getDefaultLabelHtml()}
                <textarea id="tagsEditDefaultTextArea" class="input-text textarea" data-bind="value: specificationDefault"></textarea>
            </div>

            <div class="form-group default-value" data-bind="visible: showTagSpecDetails()">
                <div class="d-flex">
                    <!-- ko if: selectedSpecType() == 2 -->
                    ${this.getDefaultLabelHtml()}
                    <!-- /ko -->
                    <!-- ko if: selectedSpecType() == 3 -->
                    ${this.getDefaultLabelHtml()}
                    <!-- /ko -->
                    <div class="w-tooltips-adv pos-top short" >
                        ${this.editSpecificationTooltip.getHtmlBuild()}
                    </div>
                </div>

                ${this.defaultTagFilter.getHtmlBuild()}

                <div class="d-flex"
                    style="flex-wrap: wrap;"
                    data-bind="
                        visible: selectedSpecType() == 3,
                        foreach: editedDefaultSelectedTags,
                        childrenComplete: handleDragAndDrop($element, editedDefaultSelectedTags, '.sortableDefaults')
                    "
                >
                    <div class="sortableDefaults" style="background: #eaeaea; width:100%;">
                        <div class="btn-f-s"
                            style="
                                background-color:#eaeaea;
                                color:#000000;
                                justify-content:space-between;
                                display:flex;
                                align-items:center;
                                padding-top:0;
                                padding-right:0;
                                margin-bottom:0!important;
                                line-height:2.0rem;
                                height:2.0rem;
                                overflow:hidden;
                                width:100%;
                            "
                        >
                            <div class="d-inline-flex" style="gap:0.5rem;">
                                <span class="icon i-drag"></span>
                                <span data-bind="text: $data.name + ($data.type != null ? ' (' + $data.type.name + ')' : '')"></span>
                            </div>
                            <button class="btn-f-s icon i-x-after"
                                data-bind="event: {click: $parent.onClickRemoveDefaultSelectedTag }"
                                style="
                                    border-top-left-radius:0;
                                    border-bottom-left-radius:0;
                                    margin-right:0!important;
                                    margin-bottom:0!important;
                                    cursor:pointer;
                                    line-height:1.7rem;
                                    height:3rem;
                                    font-size:2rem;
                                    color:#000;
                                "
                            ></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row default-value" data-bind="visible: selectedSpecType() == 4">
                ${this.getDefaultLabelHtml()}
                <input type="text" class="input-text"  data-bind="value: defaultDateSpec" placeholder="YYYY-MM-DD">
            </div>
            <div data-bind="visible: !idBrand() && selectedSpecType() == 9" class="form-group img-group">  
                ${this.getDefaultLabelHtml()} 
                ${this.imageWidgetForTagImagesSpecField.getHtmlBuild()} 
            </div>

            <!-- listTag section - no restrictions, only default tag selection -->
            <div class="form-group default-value" data-bind="visible: selectedSpecType() == 10">
                <div class="d-flex">
                    ${this.getDefaultLabelHtml()}
                </div>

                ${this.defaultTagFilter.getHtmlBuild()}

                <div class="d-flex"
                    style="flex-wrap: wrap;"
                    data-bind="
                        foreach: editedDefaultSelectedTags,
                        childrenComplete: handleDragAndDrop($element, editedDefaultSelectedTags, '.sortableListTagDefaults')
                    "
                >
                    <div class="sortableListTagDefaults" style="background: #eaeaea; width:100%;">
                        <div class="btn-f-s"
                            style="
                                background-color:#eaeaea;
                                color:#000000;
                                justify-content:space-between;
                                display:flex;
                                align-items:center;
                                padding-top:0;
                                padding-right:0;
                                margin-bottom:0!important;
                                line-height:2.0rem;
                                height:2.0rem;
                                overflow:hidden;
                                width:100%;
                            "
                        >
                            <div class="d-inline-flex" style="gap:0.5rem;">
                                <span class="icon i-drag"></span>
                                <span data-bind="text: $data.name + ($data.type != null ? ' (' + $data.type.name + ')' : '')"></span>
                            </div>
                            <button class="btn-f-s icon i-x-after"
                                data-bind="event: {click: $parent.onClickRemoveDefaultSelectedTag }"
                                style="
                                    border-top-left-radius:0;
                                    border-bottom-left-radius:0;
                                    margin-right:0!important;
                                    margin-bottom:0!important;
                                    cursor:pointer;
                                    line-height:1.7rem;
                                    height:3rem;
                                    font-size:2rem;
                                    color:#000;
                                "
                            ></button>
                        </div>
                    </div>
                </div>
            </div>
        `;
  }

  protected getInactiveTagPopupHtml(): string {
    return /* html */ `
            <div id="inactive-tag-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div id="inactive-tag-dialog-form" class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Tag Inactive</h3>
                            <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This tag is inactive for the current brand</p>
                                <p class="form-text">Activate the tag to continue</p>
                            </div>
                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCancel }" class="btn">Go Back</button>
                            <button type="button" data-bind="event: { click: onClickActivateTag }" class="btn highlight">Activate</button>
                        </div>
                    </div>
                </div>
            </div>
  `;
  }

  protected initPartial(): void {
    //Setup the locales so that we can use them in the template
    const appZone = this.caller.getVnAppZone();
    this.idBrand = appZone.app.params["idBrand"];

    this.localeHandler = new LocaleHandler(appZone, this.idBrand);

    //this.datePicker = new filterSingleDate_template("datePicker", this.getTemplateViewModel(), this.caller);
    this.imagePicker = new imagePicker_template(
      "imagePicker",
      this.getTemplateViewModel(),
      this.caller
    );
    this.tagTypeFilter = new filterTagType_template(
      "tagTypeFilter",
      this.getTemplateViewModel(),
      this.caller
    );
    this.tagFilter = new filterTag_template(
      "tagFilter",
      this.getTemplateViewModel(),
      this
    );
    this.defaultTagFilter = new filterTag_template(
      "defaultTagFilter",
      this.getTemplateViewModel(),
      this
    );
    this.defaultTagFilter.setTagContainerId("default-tags");
    this.defaultTagFilter.setTagContainerCaption("Default Tags:");
    this.restrictionFilter = new filterAutocomplete_template(
      "restrictionFilter",
      this.getTemplateViewModel(),
      this.caller
    );
    this.restrictionFilter.setPlaceholderAndLabel("Tag Restriction");

    this.activeTagsEditPageTooltipContent = `
        <p>
        This field controls if a tag can be Available for Use and whether it can appear in the Tag Picker.
        </p>
        `;
    this.activeTagsEditPageTooltip = new infoButton_template(
      "activeTagsEditPageTooltip",
      this.getTemplateViewModel(),
      this.caller
    );
    this.activeTagsEditPageTooltip.setTitle("Tag Active Status");
    this.activeTagsEditPageTooltip.setContent(
      this.activeTagsEditPageTooltipContent
    );

    this.selectableTagsEditPageTooltipContent = `
        <p>
        This field controls if the tag is available to select in Article categorization and Hub Page configuration.
        </p>
        `;
    this.selectableTagsEditPageTooltip = new infoButton_template(
      "selectableTagsEditPageTooltip",
      this.getTemplateViewModel(),
      this.caller
    );
    this.selectableTagsEditPageTooltip.setTitle("Tag Selection");
    this.selectableTagsEditPageTooltip.setContent(
      this.selectableTagsEditPageTooltipContent
    );

    this.seoDescriptionTooltipContent = `
        <p>
        This is the description provided in the product schema on the website,
        which is leveraged by search engines (like Google), to better understand
        the content and can be displayed to users in search results.  It should be a short,
        natural, and engaging blurb about the product, which users would find relevant.
        </p>
        `;
    this.seoDescriptionTooltip = new infoButton_template(
      "seoDescriptionTooltip",
      this.getTemplateViewModel(),
      this.caller
    );
    this.seoDescriptionTooltip.setTitle("Seo Description");
    this.seoDescriptionTooltip.setContent(this.seoDescriptionTooltipContent);

    this.editSpecificationTooltipContent = `
        <p>All tags are displayed here but only those marked with a green indicator are currently available for use by your brand.</p>
        <ul>
            <li class="is-active">Available for use.</li>
            <li class="is-not-active">Not available for use.</li>
        </ul>
        `;
    this.editSpecificationTooltip = new infoButton_template(
      "editSpecificationTooltip",
      this.getTemplateViewModel(),
      this.caller
    );
    this.editSpecificationTooltip.setTitle("Tag Selection");
    this.editSpecificationTooltip.setContent(
      this.editSpecificationTooltipContent
    );

    this.automaticPricingTooltipContent = `
        <p>
        When checked the most up-to-date pricing will be used if it is available.
        </p>
        `;
    this.automaticPricingTooltip = new infoButton_template(
      "automaticPricingTooltip",
      this.getTemplateViewModel(),
      this.caller
    );
    this.automaticPricingTooltip.setTitle("Automatic Pricing");
    this.automaticPricingTooltip.setContent(
      this.automaticPricingTooltipContent
    );

    this.filterAffiliates = new filterAutocomplete_template(
      "filterAutocompleteAffiliate_template",
      this.getTemplateViewModel(),
      this.caller
    );
    this.filterAffiliates.setAddNewOptionEnabled(true);
    this.filterAffiliates.setNumberOfChars(1);
    this.filterAffiliates.setPlaceholderAndLabel("Affiliate Partner");
    this.filterAffiliates.setOptionType("Affiliate Partner");

    this.filterLocales = new filterAutocomplete_template(
      "filterAutocompleteLocales_template",
      this.getTemplateViewModel(),
      this.caller
    );
    this.filterLocales.setAddNewOptionEnabled(false);
    this.filterLocales.setNumberOfChars(1);
    this.filterLocales.setPlaceholderAndLabel("GEO");
    this.filterLocales.setOptionType("GEO");

    this.imagePickerHelper = new imagePickerHelper(
      this.imagePicker,
      this.caller.viewModel,
      this.caller.getVnAppZone(),
      this.caller
    );

    this.imageWidgetForBrandTagImage = new imageWidget_template(
      "tag_image",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForBrandTagImage.setMode("single-select");
    this.imageWidgetForBrandTagImage.setCaller(this.imagePickerHelper);

    this.imageWidgetForTagIconImage = new imageWidget_template(
      "tag_image_icon",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForTagIconImage.setMode("single-select");
    this.imageWidgetForTagIconImage.setCaller(this.imagePickerHelper);

    this.imageWidgetForTagBannerImage = new imageWidget_template(
      "tag_banner_image",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForTagBannerImage.setMode("single-select");
    this.imageWidgetForTagBannerImage.setCaller(this.imagePickerHelper);

    this.imageWidgetForBrandTagImageGroup = new imageWidget_template(
      "tag_image_group",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForBrandTagImageGroup.setMode("multi-select-no-gallery");
    this.imageWidgetForBrandTagImageGroup.setCaller(this.imagePickerHelper);

    this.imageWidgetForDefaultBrandTagImage = new imageWidget_template(
      "default_tag_image",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForDefaultBrandTagImage.setMode("single-select");
    this.imageWidgetForDefaultBrandTagImage.setCaller(this.imagePickerHelper);

    this.imageWidgetForDefaultTagIconImage = new imageWidget_template(
      "default_tag_image_icon",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForDefaultTagIconImage.setMode("single-select");
    this.imageWidgetForDefaultTagIconImage.setCaller(this.imagePickerHelper);

    this.imageWidgetForDefaultTagBannerImage = new imageWidget_template(
      "default_tag_banner_image",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForDefaultTagBannerImage.setMode("single-select");
    this.imageWidgetForDefaultTagBannerImage.setCaller(this.imagePickerHelper);

    this.imageWidgetForDefaultBrandTagImageGroup = new imageWidget_template(
      "default_tag_image_group",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForDefaultBrandTagImageGroup.setMode(
      "multi-select-no-gallery"
    );
    this.imageWidgetForDefaultBrandTagImageGroup.setCaller(
      this.imagePickerHelper
    );

    this.imageWidgetForTagImagesSpecField = new imageWidget_template("images_spec_field", this.getTemplateViewModel(), this);
    this.imageWidgetForTagImagesSpecField.setMode("multi-select-no-gallery");
    this.imageWidgetForTagImagesSpecField.setCaller(this.imagePickerHelper);


    this.tagVideoPicker = new videoPicker_template(
      "tagVideoPicker",
      this.getTemplateViewModel(),
      this.caller
    );
    this.videoPickerHelper = new videoPickerHelper(
      this.tagVideoPicker,
      this.caller.viewModel,
      this.caller.getVnAppZone(),
      this.caller
    );

    this.linkExpirationDatePicker = new filterSingleDate_template(
      "linkExpirationDatePicker",
      this.getTemplateViewModel(),
      this.caller
    );
    this.linkExpirationDatePicker.setDate(
      this.getFormattedEasternTimeZoneDateTime("/")
    );

    this.defaultVignetteFilter = new filterAutocomplete_template(
      "defaultVignetteFilter",
      this.getTemplateViewModel(),
      this.caller
    );
    this.defaultVignetteFilter.setPlaceholderAndLabel("Vignette");

    this.defaultVignettePreview = new vignettePreview_template(
      "defaultVignettePreview",
      this.getTemplateViewModel(),
      this.caller
    );

    this.vignetteFilter = new filterAutocomplete_template(
      "vignetteFilter",
      this.getTemplateViewModel(),
      this.caller
    );
    this.vignetteFilter.setPlaceholderAndLabel("Vignette");

    this.vignettePreview = new vignettePreview_template(
      "vignettePreview",
      this.getTemplateViewModel(),
      this.caller
    );

      this.reviewScoreEmbargoEndDate = new filterSingleDate_template(
          "reviewScoreEmbargoEndDate",
          this.getTemplateViewModel(),
          this.caller
      );
      this.reviewScoreEmbargoEndDate.setDate(null);
  }

  protected getTemplateName(): string {
    return "tagsEdit-template";
  }

  protected getMainElementType(): string {
    return "div";
  }

  protected getMainElementClasses(): Array<string> {
    return ["w-form", "w-form-large", "form-create-tag"];
  }

  protected buildViewModel(): any {
    let huit_neuf_this = this;
    let vm = {
      id: ko.observable(),
      idBrand: ko.observable(null),
      brand: ko.observable(null),
      name: ko.observable(),
      idReference: ko.observable(null),
      referenceDescription: ko.observable(null),
      type: ko.observable(),
      slug: ko.observable("/tag/"),
      urlHubPage: ko.observable(null),
      tagColor: ko.observable(),
      tagVideoThumbnailURL: ko.observable(null),
      tagVideoURL: ko.observable(null),
      tagVideoTitle: ko.observable(null),
      tagVideo: ko.observable(null),
      reviewScore: ko.observable(null),
      reviewScoreIsUnderEmbargo: ko.observable(false),
      description: ko.observable(""),
      isTagSelectable: ko.observable(0),
      isTagActive: ko.observable(1),
      hasSlug: ko.observable(false),
      specificationLabel: ko.observable(null),
      specificationReference: ko.observable(null),
      specificationIsForcedOverwrite: ko.observable(false),
      specificationData: ko.observable(null),
      specificationExtra: ko.observable({ ratingScale: null }),
      providerName: ko.observable(null),
      ratingScale: ko.observable(null),
      defaultRatingScale: ko.observable(null),
      specificationDefault: ko.observable(null),
      tagType: ko.observable(),
      isAddSpecVisible: ko.observable(),
      specEdited: ko.observable(),
      idField: ko.observable(),
      popupTitle: ko.observable(),
      idTagType: ko.observable(),
      isForcedOverwrite: ko.observable(),
      providers: ko.observableArray([]),
      specifications: ko.observableArray([]),
      validAutoPricingPartnerNames: ko.observableArray([]),
      pendingSpecToAdd: ko.observable(),
      specTypes_options: ko.observableArray(SPEC_DATA_TYPES),
      specTypeMap: ko.observable(SPEC_TYPE_MAP),
      tagType_options: ko.observableArray([]),
      tag_options: ko.observableArray([]),
      selectedSpecType: ko.observable(null),
      restrictionType: ko.observable(),
      selectedTag: ko.observable(),
      defaultSelectedTag: ko.observable(),
      editedSelectedTags: ko.observableArray([]),
      editedDefaultSelectedTags: ko.observableArray([]),
      selectedTags: ko.observableArray(),
      defaultSelectedTags: ko.observableArray(),
      dateSpec: ko.observable(null),
      defaultDateSpec: ko.observable(null),
      useDefault: ko.observable(null),
      useOverride: ko.observable(null),
      isBrandOwner: ko.pureComputed(() => {
        return (
          huit_neuf_this.getTemplateViewModel().idBrandOwner() &&
          huit_neuf_this.getTemplateViewModel().idBrandOwner() ==
            huit_neuf_this.getTemplateViewModel().idBrand()
        );
      }),
      automaticDefault: ko.pureComputed(
        () =>
          !huit_neuf_this.getTemplateViewModel().idBrand() ||
          huit_neuf_this.getTemplateViewModel().isBrandOwner()
      ),
      idBrandOwner: ko.observable(""),
      brandOwner: ko.observable(null),
      canEditThisTag: ko.observable(false),
      specDefaults: ko.observableArray([]),
      permissions: ko.observableArray(
        this.initPermissions([
          "tag_edit",
          "tag_type_field_label_edit",
          "vignettes",
          "tag_color",
          "article_edit_embargo",
        ])
      ),
      affiliateLinks: ko.observableArray(),
      affiliateOptionLinks: ko.observableArray(),
      reviewText: ko.observable(),
      seoDescription: ko.observable(),
      restrictionTypeArray: ko.observableArray([]),
      oldRestrictionTypeArray: ko.observableArray([]),
      isAffiliateLinksFormShown: ko.observable(false),
      isAffiliateLinksFormAdvancedVisible: ko.observable(false),
      affiliateUrl: ko.observable(null),
      isAutoLinkerEnabled: ko.observable(false),
      autoAffiliateEmakiAutolinker: ko.observable(true),
      isAutoLinkerThirdPartyServiceEnabled: ko.observable(false),
      autoAffiliateThirdPartyService: ko.observable(true),
      affiliateAutomaticPricing: ko.observable(null),
      affiliateAutomaticPricingAvailable: ko.observable(false),
      affiliateSalePrice: ko.observable(null),
      affiliatePrice: ko.observable(null),
      affiliateExpiration: ko.observable(null),
      affiliateExpirationOption: ko.observable(1),
      affiliateLinkTextOverride: ko.observable(null),
      affiliateOptionsString: ko.observable(null),
      showContainsString: ko.observable(false),
      countryCode: ko.observable(null),
      option: ko.observable(null),
      affiliateLinkError: ko.observable(null),
      streamRentBuyLinks: ko.pureComputed(() => {
        // optionable links are automatically populated, and have an option set
        return huit_neuf_this.getTemplateViewModel().affiliateLinks()
          ? huit_neuf_this
              .getTemplateViewModel()
              .affiliateLinks()
              .filter(streamRentBuyFilter)
          : [];
      }),
      hasStreamRentBuyLinks: ko.pureComputed(() => {
        return (
          huit_neuf_this.getTemplateViewModel().streamRentBuyLinks().length > 0
        );
      }),
      tagDefaultColor: ko.observable(""),
      defaultStreamRentBuyLinks: ko.pureComputed(() => {
        // optionable links are automatically populated, and have an option of stream, rent, or buy set
        const vm = huit_neuf_this.getTemplateViewModel();

        return vm.tagDefaults() && vm.tagDefaults().affiliateLinks
          ? vm.tagDefaults().affiliateLinks.filter(streamRentBuyFilter)
          : [];
      }),
      defaultsHaveStreamRentBuyLinks: ko.pureComputed(() => {
        return (
          huit_neuf_this.getTemplateViewModel().defaultStreamRentBuyLinks()
            .length > 0
        );
      }),
      linkIndex: ko.observable(null),
      showAutoCalculateReviewScore: ko.observable(false),
      filterVignetteOptions: ko.observable([]),
      indexedValues: ko.observable({}),
      idSelectedVignette: ko.observable(null),
      idSelectedDefaultVignette: ko.observable(null),
      pullWatchmodeData: ko.observable(false),
      showTagSpecDetails: ko.pureComputed(() =>
        huit_neuf_this.shouldShowTagSpecDetails()
      ),
      showPlainTextField: ko.pureComputed(() =>
        huit_neuf_this.shouldShowPlainTextEntry()
      ),
      showImagesField: ko.pureComputed(() =>
          huit_neuf_this.shouldShowImagesEntry()
      ),
      onClickActivateTag: function (data, event) {
        huit_neuf_this.onClickActivateTag();
      },
      buildAffiliateOptionsString: function () {
        let optionNames = [];
        const streamLinks = TagDefaultsHelper.getAffiliateLinks(huit_neuf_this.getTemplateViewModel());
          for (let sl in streamLinks) {
            if (streamLinks[sl].option && streamLinks[sl].option != "" && optionNames.filter(name => name.name.toLowerCase() === streamLinks[sl].option.toLowerCase()).length == 0) {
              optionNames.push({name: streamLinks[sl].option, count: 1});
            } else if (streamLinks[sl].option && streamLinks[sl].option != "" && optionNames.filter(name => name.name.toLowerCase() === streamLinks[sl].option.toLowerCase()).length >= 0) {
              optionNames.filter(name => name.name.toLowerCase() === streamLinks[sl].option.toLowerCase())[0].count++;
            }
          }

          if (optionNames.length <= 0) {
            huit_neuf_this.getTemplateViewModel().showContainsString(false);
            return "";
          }

          huit_neuf_this.getTemplateViewModel().showContainsString(true);

          let optionString = "Contains ";

          for (let on in optionNames) {
            optionString += "<span style=\"padding-bottom: 0;transform: none;\">" + optionNames[on].count + " " + optionNames[on].name + " / </span>";
          }

          return optionString.slice(0, optionString.length - 9) + "</span> Option Links";
      },
      getAffiliateOptionsList: function () {
        return TagDefaultsHelper.getAffiliateLinks(huit_neuf_this.getTemplateViewModel());
      },
      onBlurTagType: function (value, data, event) {
        huit_neuf_this.onBlurTagType(value);
      },
      onBlurRestrictionType: function (value, data, event) {
        huit_neuf_this.onBlurRestrictionType(value);
      },
      onClickSave: function () {
        huit_neuf_this.onClickSave();
      },
      onClickCancel: function () {
        huit_neuf_this.onClickCancel();
      },
      onChangeSpecificationType: function () {
        huit_neuf_this.onChangeSpecificationType();
      },
      onClickSelectVideo: function () {
        huit_neuf_this.onClickSelectVideo();
      },
      onClickWatchVideo: function () {
        huit_neuf_this.onClickWatchVideo();
      },
      onClickRemoveVideo: function () {
        huit_neuf_this.onClickRemoveVideo();
      },
      onClickAddSpecification: function () {
        huit_neuf_this.onClickAddSpecification();
      },
      onClickSaveSpecification: function () {
        huit_neuf_this.onClickSaveSpecification();
      },
      onClickCancelSaveSpecification: function () {
        huit_neuf_this.onClickCancelSaveSpecification();
      },
      onClickEditSpecification: function (value, data, event) {
        huit_neuf_this.onClickEditSpecification(value);
      },
      onClickDeleteSpecification: function (value, data, event) {
        huit_neuf_this.onClickDeleteSpecification(value);
      },
      onClickRemoveSelectedTag: function (data, event) {
        huit_neuf_this.onClickRemoveSelectedTag(data);
      },
      onClickRemoveDefaultSelectedTag: function (data, event) {
        huit_neuf_this.onClickRemoveDefaultSelectedTag(data);
      },
      onClickAddAffiliateLink: function (value, data, event) {
        huit_neuf_this.onClickAddAffiliateLink();
      },
      onClickDeleteAffiliateLinks: function (value, data, event) {
        huit_neuf_this.onClickDeleteAffiliateLinks(data, value);
      },
      onClickCancelAffiliateLink: function (data, event) {
        huit_neuf_this.onClickCancelAffiliateLink();
      },
      onClickShowAffiliateLink: function (data, event) {
        huit_neuf_this.onClickShowAffiliateLink();
      },
      onClickShowAffiliateOptionLink: function (data, event) {
        huit_neuf_this.onClickShowAffiliateLink(true);
      },
      onClickDeleteLink: function (data, event) {
        huit_neuf_this.onClickDeleteLink(data);
      },
      onClickEditLink: function (data, event) {
        huit_neuf_this.onClickEditLink(data);
      },
      onClickEditOptionsLink: function (data, event) {
        huit_neuf_this.onClickEditLink(data, true);
      },
      onClickDeleteRestrictionTypeArray: function (data, event) {
        huit_neuf_this.onClickDeleteRestrictionTypeArray(data);
      },
      onClickAutoCalculateReviewScore: function (data, event) {
        huit_neuf_this.onClickAutoCalculateReviewScore(data);
      },
      onClickSetAllSpecificationsToDefault: function () {
        huit_neuf_this.onClickSetAllSpecificationsToDefault();
      },

        onChangeSetReviewScoreEmbargoEndDate: function (data, event){
            huit_neuf_this.onChangeSetReviewScoreEmbargoEndDate(data, event);
        },
      onClickUseDefaultTagValue: function (data, event) {
          TagDefaultsHelper.onClickUseDefaultTagValue(
            data,
            event,
            huit_neuf_this.getTemplateViewModel());
            huit_neuf_this.getTemplateViewModel().affiliateOptionLinks(huit_neuf_this.getTemplateViewModel().getAffiliateOptionsList());
            huit_neuf_this.getTemplateViewModel().affiliateOptionsString(huit_neuf_this.getTemplateViewModel().buildAffiliateOptionsString());
      },
      getBrandOwnerInfoText: () =>
        TagDefaultsHelper.getBrandOwnerInfoText(
          huit_neuf_this.getTemplateViewModel().brandOwner()
        ),
      handleDragAndDrop: function (
        element,
        currentObservableArray,
        childrenSelector
      ) {
        huit_neuf_this.handleDragAndDrop(
          element,
          currentObservableArray,
          childrenSelector
        );
      },
      hasDefaultDataAvailable: ko.pureComputed(() => {
        const vm = huit_neuf_this.getTemplateViewModel();
        return (
          vm.specDefaults().length > 0 &&
          vm.idBrand() &&
          vm.idBrandOwner() &&
          !vm.isBrandOwner()
        );
      }),
      hasSpecDefault: function (idField: number): boolean {
        // use to signify the presence of a default
        return (
          huit_neuf_this
            .getTemplateViewModel()
            .specDefaults()
            .findIndex((specDefault) => idField === specDefault.fieldId) >= 0
        );
      },
      getSpecDefault: function (
        spec: any,
        optionalMessageWhenEmpty: string | null
      ): string | null {
        const dataType = spec.dataType.toLowerCase();
        const idField = spec.fieldId;

        const record = idField
          ? huit_neuf_this.getTemplateViewModel().getSpecDefaultData(idField)
          : spec;

        if (!record || !record.value) {
          return optionalMessageWhenEmpty;
        }

        return huit_neuf_this.specDisplayValue(
          dataType,
          record,
          optionalMessageWhenEmpty
        );
      },
      getSpecDefaultAtIdField: ko.pureComputed(() => {
        const vm = huit_neuf_this.getTemplateViewModel();
        const optionalMessageWhenEmpty = "[CURRENTLY EMPTY]";

        if (!vm.idField()) {
          return "";
        }

        const record = huit_neuf_this
          .getTemplateViewModel()
          .getSpecDefaultData(vm.idField());

        const append = record && record.dataType === "rating" ? `/${record.ratingScale}` : "";

        return record
          ? `${huit_neuf_this.specDisplayValue(
              record.dataType,
              record,
              optionalMessageWhenEmpty
            )}${append}`
          : optionalMessageWhenEmpty;
      }),
      getRawSpecDefaultData: function (spec: any): any {
        // use to display the default
        const defaultData = spec.fieldId
          ? huit_neuf_this
              .getTemplateViewModel()
              .getSpecDefaultData(spec.fieldId)
          : spec;

        if (!defaultData) {
          return null;
        }

        return defaultData.value;
      },
      getSpecDefaultData: function (idField: number): any | null {
        const defaultIndex = huit_neuf_this
          .getTemplateViewModel()
          .specDefaults()
          .findIndex((specDefault) => idField == specDefault.fieldId); // defaults come back with fieldId, not idField

        if (defaultIndex < 0) {
          return null;
        }

        return huit_neuf_this.getTemplateViewModel().specDefaults()[
          defaultIndex
        ];
      },
      getSpecLabel: (spec: any): string => {
        if (
          huit_neuf_this.getTemplateViewModel() &&
          (!huit_neuf_this.getTemplateViewModel().idBrand() || spec.isDefault)
        ) {
          const defaultSpec = spec.fieldId
            ? huit_neuf_this
                .getTemplateViewModel()
                .getSpecDefaultData(spec.fieldId)
            : null;
          if (defaultSpec) {
            // might have default set, but no default spec yet, or this is a new field
            spec = defaultSpec;
            spec.isDefault = true;
          }
        }

        if (!spec.ratingScale) {
          return spec.label;
        } else {
          return (
            spec.label +
            " / " +
            (spec.isDefault
              ? `<span>${spec.ratingScale}</span>`
              : spec.ratingScale)
          );
        }
      },
      isDataTypeJSON: function (
        dataType: string
      ): boolean {
        return dataType.endsWith("JSON");
      },
      ...TagDefaultsHelper.viewModelProperties,
      imageGroupSummary: (imageGroup: any): string =>
        TagDefaultsHelper.imageGroupSummary(imageGroup),
      affiliateLinksSummary: (affiliateLinks) =>
        huit_neuf_this.getTemplateViewModel()
          ? TagDefaultsHelper.affiliateLinksSummary(
              affiliateLinks,
              huit_neuf_this
                .getTemplateViewModel()
                .defaultsHaveStreamRentBuyLinks()
            )
          : null,
    };

    // need this, as the properties of tagDefaults don't seem to be reactive to changes. This determines the color preview background.
    vm.tagDefaults.subscribe((newValue, oldValue) => {
      if (oldValue === undefined || newValue.tagColor !== oldValue.tagColor) {
        vm.tagDefaultColor(newValue.tagColor);
      }
    });

    vm.useTagDefaults.subscribe((newValue) => {
      if (vm.automaticDefault()) {
        huit_neuf_this.caller.refreshDescriptionCkEditor();
      } else {
        if (!newValue.description) {
          // setTimeout(() => this.initTagDescriptionEditor(), 100);
          huit_neuf_this.caller.refreshDescriptionCkEditor();
        } else {
          for (let name in CKEDITOR.instances) {
            if (name === "product_review_text") {
              CKEDITOR.instances[name].destroy(true);
            }
          }
        }
      }
    });

    vm.tagType.subscribe(() => {
      huit_neuf_this.setupCanEditThisTag();
    });
    vm.name.subscribe(() => {
      huit_neuf_this.setupCanEditThisTag();
    });
    vm.isTagActive.subscribe((isTagActive) => {
      if (!isTagActive) {
        vm.isTagSelectable(false);
      }
    });

      const embargoPermissions = ko.pureComputed(() => {
          const permissions = vm.permissions()["article_edit_embargo"];
          const { read = false, write = false } = permissions || {};
          return { read, write };
      });

      return {...vm , embargoPermissions};
  }

  public specDisplayValue = (
    dataType: string,
    record: any,
    optionalMessageWhenEmpty: string = ""
  ) => {
    if (dataType === "tag") {
      return record.value && record.value[0]
        ? `${record.value[0].name} ${record.value[0].formattedTagTypeAndDataset}`
        : optionalMessageWhenEmpty;
    } else if (dataType === "tags" || dataType === "listtag") {
      return record.value && record.value.length > 0
        ? record.value.map((rec) =>
            rec.type
              ? `${rec.name} ${rec.formattedTagTypeAndDataset}`
              : rec.name
          )
        : optionalMessageWhenEmpty;
    } else if (dataType === "rating") {
      return record.value || record.value === 0 || record.value === "0"
        ? record.value
        : null;
    } else if (dataType === "images") {
      let msg = Array.isArray(record.value) && record.value.length > 0
          ? record.value.length + " images in group"
          : optionalMessageWhenEmpty;

      return msg;
    } else {
      return record.value;
    }
  };

  public handleDragAndDrop(
    element,
    currentObservableArray,
    childrenSelector
  ): any {
    DragAndDropHandler.handleDragAndDrop(
      element,
      currentObservableArray,
      childrenSelector
    );
  }

  public getViewModelForRequest() {
    const vm = this.getTemplateViewModel();

    let reviewText = this.caller.getReviewText();

    if (vm.automaticDefault()) {
      vm.tagDefaults({
        ...vm.tagDefaults(),
        tagColor: vm.tagDefaultColor(),
        description: this.caller.getReviewText(),
        image: this.imageWidgetForDefaultBrandTagImage.getImage(),
        iconImage: this.imageWidgetForDefaultTagIconImage.getImage(),
        bannerImage: this.imageWidgetForDefaultTagBannerImage.getImage(),
        imageGroup:
          this.imageWidgetForDefaultBrandTagImageGroup.getSelectedImagesMarkup(),
        idVignette: vm.idSelectedDefaultVignette(),
      });
      reviewText = "";
    }

    // remove infoButton from providers since we don't need it there
    let providers = vm.providers();
    for (let provider of providers) {
      if (provider["infoButton"]) {
        provider["infoButton"] = null;
      }
    }

    return {
      idTag: vm.id(),
      name: vm.name(),
      idTagType: vm.tagTypeFilter.idTagType(),
      providers: providers,
      specifications: vm.specifications(),
      specDefaults: vm.specDefaults(),
      tagImage: this.imageWidgetForBrandTagImage.getImage(),
      iconImage: this.imageWidgetForTagIconImage.getImage(),
      bannerImage: this.imageWidgetForTagBannerImage.getImage(),
      tagImageGroup:
        this.imageWidgetForBrandTagImageGroup.getSelectedImagesMarkup(),
      slug: vm.slug(),
      urlHubPage: vm.urlHubPage(),
      isTagSelectable: vm.isTagSelectable(),
      isTagActive: vm.isTagActive(),
      description: vm.description(),
      seoDescription: vm.seoDescription(),
      affiliateLinks: vm.affiliateLinks(),
      reviewScore: vm.reviewScore(),
      tagDefaults: vm.tagDefaults(),
      useTagDefaults: vm.useTagDefaults(),
      reviewText: reviewText,
      idVignette: vm.idSelectedVignette(),
      tagColor: vm.tagColor(),
      idTagVideo: vm.tagVideo() ? vm.tagVideo().id : null,
      reviewScoreIsUnderEmbargo: vm.reviewScoreIsUnderEmbargo(),
      reviewScoreEmbargoEndDate: vm.reviewScoreEmbargoEndDate.singleDatePicker(),
      pullWatchmodeData: vm.pullWatchmodeData(),
    };
  }

  public setSelectedVignette(vignette) {
    this.getTemplateViewModel().idSelectedVignette(
      vignette ? vignette.id : null
    );
    this.vignettePreview.setVignette(vignette);
  }

  public setSelectedDefaultVignette(vignette) {
    this.getTemplateViewModel().idSelectedDefaultVignette(
      vignette ? vignette.id : null
    );
    this.defaultVignettePreview.setVignette(vignette);
  }

  public setIndexedValues(
    tag,
    specValues: Array<any>,
    specDefaults: Array<any> = []
  ) {
    this.vignettePreview.setIndexedValues(tag, specValues, specDefaults);
    this.defaultVignettePreview.setIndexedValues(tag, specValues, specDefaults);
  }

  public setBrandOwner(brandOwner: emaki_brand | null): void {
    this.getTemplateViewModel().brandOwner(brandOwner);
    this.setIdBrandOwner(brandOwner ? brandOwner.id : null);
  }

  public setIdBrandOwner(idBrandOwner: number | null) {
    this.getTemplateViewModel().idBrandOwner(idBrandOwner);
  }

  public setupCanEditThisTag = () => {
    const vm = this.getTemplateViewModel();

    // new tag, or one that this user can edit
    this.getTemplateViewModel().canEditThisTag(
      !vm.id() ||
        userCanEditOwnedTagType(
          this.caller.vnAppZone,
          vm.permissions(),
          vm.idBrand(),
          vm.idBrandOwner()
        )
    );
  };

  public setupUseTagDefaults(tag = null): void {
    const vm = this.getTemplateViewModel();

    return TagDefaultsHelper.setupUseTagDefaults(
      vm,
      this.imageWidgetForBrandTagImage,
      this.imageWidgetForTagIconImage,
      this.imageWidgetForTagBannerImage,
      this.imageWidgetForBrandTagImageGroup,
      tag
    );
  }

  public getLocales() {
    this.locales = this.localeHandler.locales();
    return this.locales;
  }

  public setVideoPickerTagFilter(tags) {
    this.videoPickerHelper.setTagsSuggestions(tags);
  }

  public onClickSave() {
    this.caller.saveTag();
  }

  public onClickCancel() {
    this.caller.cancel();
  }

  public onClickSelectVideo() {
    this.videoPickerHelper.setTarget("tagVideo");
    this.videoPickerHelper.showVideoPicker();
    this.videoPickerHelper.getVideosData();
  }

  public onClickRemoveVideo() {
    this.getTemplateViewModel().tagVideo(null);
    this.getTemplateViewModel().tagVideoURL(null);
    this.getTemplateViewModel().tagVideoTitle(null);
    this.getTemplateViewModel().tagVideoThumbnailURL(null);
  }

  public onClickWatchVideo() {
    let videoURL = this.getTemplateViewModel().tagVideoURL();
    if (videoURL) {
      window.open(videoURL, "_blank");
    }
  }

  public setTagVideo(video) {
    this.getTemplateViewModel().tagVideo(video);
    if (video) {
      this.getTemplateViewModel().tagVideoURL(video.url);
      this.getTemplateViewModel().tagVideoThumbnailURL(video.thumbnail.url);
      this.getTemplateViewModel().tagVideoTitle(video.title);
    }
  }

  protected onClickAddSpecification() {
    this.getTemplateViewModel().isAddSpecVisible(true);
    this.getTemplateViewModel().popupTitle("Add Specification");
  }

  protected onClickSetAllSpecificationsToDefault() {
    let specifications = this.getTemplateViewModel().specifications();

    for (let spec of specifications) {
      spec.isDefault = true;
    }

    this.getTemplateViewModel().specifications([]);
    this.getTemplateViewModel().specifications(specifications);
  }

  protected onClickCancelAffiliateLink() {
    this.getTemplateViewModel().isAffiliateLinksFormShown(false);
    this.getTemplateViewModel().isAffiliateLinksFormAdvancedVisible(false);
  }

  //TODO: remove this function if we dont use it
  protected getAffiliateLinkIndex(affiliateLinks, link) {
    if (!affiliateLinks || !link) {
      return -1;
    }

    if (link.id) {
      return affiliateLinks.findIndex((l) => l.id == link.id ||
       (l.url && link.url && l.url == link.url));
    }

    if (link.url) {

    }
  }

  protected onClickEditLink(link, useAdvanced = false) {
    let validAutoPricingPartnerNames =
      this.getTemplateViewModel().validAutoPricingPartnerNames();
    let affiliateLinks = this.getTemplateViewModel().automaticDefault()
      ? this.getTemplateViewModel().tagDefaults().affiliateLinks
      : this.getTemplateViewModel().affiliateLinks();
    let linkIndex = affiliateLinks.findIndex((l) => l == link || (l.id && link.id && l.id == link.id));

    // get what is already set on the link
    let isAutomatic =
      link.automaticPricing == true ||
      link.automaticPricing == "true" ||
      link.automaticPricing == 1;
    let isLinkAutomaticAvailable =
      link.affiliateAutomaticPricingAvailable == true ||
      link.affiliateAutomaticPricingAvailable == "true" ||
      link.affiliateAutomaticPricingAvailable == 1;

      if (!link.hasOwnProperty('autoAffiliateEmakiAutolinker')) {
          link.autoAffiliateEmakiAutolinker = true;
      }

    let autoAffiliateEmakiAutolinker = link.autoAffiliateEmakiAutolinker == true ||
        link.autoAffiliateEmakiAutolinker == 'true' ||
        link.autoAffiliateEmakiAutolinker == 1;

      if (!link.hasOwnProperty('autoAffiliateThirdPartyService')) {
          link.autoAffiliateThirdPartyService = true;
      }

    let autoAffiliateThirdPartyService = link.autoAffiliateThirdPartyService == true ||
        link.autoAffiliateThirdPartyService == 'true' ||
        link.autoAffiliateThirdPartyService == 1;

    // whether automatic pricing is available from the db
    let isAutomaticAvailable =
      typeof link.type !== "undefined" &&
      validAutoPricingPartnerNames.includes(link.type);

    this.getTemplateViewModel().linkIndex(linkIndex);

    this.resetAffiliateForm();
    this.getTemplateViewModel().affiliatePrice(link.price);
    this.getTemplateViewModel().affiliateSalePrice(link.salePrice);
    this.getTemplateViewModel().autoAffiliateEmakiAutolinker(autoAffiliateEmakiAutolinker);
    this.getTemplateViewModel().autoAffiliateThirdPartyService(autoAffiliateThirdPartyService);
    this.getTemplateViewModel().affiliateAutomaticPricing(isAutomatic);
    this.getTemplateViewModel().affiliateAutomaticPricingAvailable(
      isAutomaticAvailable
    );
    this.getTemplateViewModel().affiliateLinkTextOverride(
      link.linkTextOverride
    );
    this.getTemplateViewModel().countryCode(
      link.countryCode
    );

    this.getTemplateViewModel().option(
      link.option
    );
    this.getTemplateViewModel().affiliateExpirationOption(1);
    this.getTemplateViewModel().affiliateUrl(link.value);

    this.filterAffiliates.setOption({
      name: link.type,
      id: link.id,
      showAutoPricing: isAutomatic,
      hasPricingSources: isLinkAutomaticAvailable,
      option: (link.option) ? link.option : null,
    });

    let selectedLocale = this.localeHandler.getLocaleByCountryCode(link.countryCode);

    if (selectedLocale) {
      this.filterLocales.setOption({
        name: selectedLocale.name,
        countryCode: selectedLocale.countryCode,
        idLocale: selectedLocale.id,
        currency: selectedLocale.currency,
        locale: selectedLocale.fullLocale,
      });
    }

    if (link.dateExpiration != null) {
      //check if expiry date has passed
      let currentDate = this.createEasternTimeZoneDateTime();
      let dateExpiration = new Date(link.dateExpiration);

      if (dateExpiration > currentDate) {
        //scheduled
        this.getTemplateViewModel().affiliateExpirationOption(3);
        this.linkExpirationDatePicker.setDate(
          link.dateExpiration.replaceAll("-", "/")
        );
      } else {
        //expired
        this.getTemplateViewModel().affiliateExpirationOption(2);
      }
    }

    this.getTemplateViewModel().isAffiliateLinksFormAdvancedVisible(useAdvanced);
    this.getTemplateViewModel().isAffiliateLinksFormShown(true);

  }

  protected onClickDeleteLink(data) {
    let affiliateLinks = this.getTemplateViewModel().automaticDefault()
      ? this.getTemplateViewModel().tagDefaults().affiliateLinks
      : this.getTemplateViewModel().affiliateLinks();

    affiliateLinks = affiliateLinks.filter(
      (l) => l.id + "_" + l.value != data.id + "_" + data.value
    );

    if (this.getTemplateViewModel().automaticDefault()) {
      TagDefaultsHelper.updateTagDefaultValue(
        this.getTemplateViewModel(),
        "affiliateLinks",
        affiliateLinks
      );
    } else {
      this.getTemplateViewModel().affiliateLinks([]);
      this.getTemplateViewModel().affiliateLinks(affiliateLinks);
    }
    this.getTemplateViewModel().affiliateOptionLinks(this.getTemplateViewModel().getAffiliateOptionsList());
    this.getTemplateViewModel().affiliateOptionsString(this.getTemplateViewModel().buildAffiliateOptionsString());
  }

  protected onClickShowAffiliateLink(useAdvanced = false) {
    this.resetAffiliateForm();
    this.getTemplateViewModel().affiliateLinkError(null);
    this.getTemplateViewModel().linkIndex(null);
    this.getTemplateViewModel().isAffiliateLinksFormShown(true);
    this.getTemplateViewModel().isAffiliateLinksFormAdvancedVisible(useAdvanced);
  }

  protected resetAffiliateForm() {
    this.getTemplateViewModel().affiliateLinkError(null);
    this.getTemplateViewModel().affiliatePrice(null);
    this.getTemplateViewModel().affiliateAutomaticPricingAvailable(false);
    this.getTemplateViewModel().autoAffiliateEmakiAutolinker(true);
    this.getTemplateViewModel().autoAffiliateThirdPartyService(true);
    this.getTemplateViewModel().affiliateAutomaticPricing(null);
    this.getTemplateViewModel().affiliateSalePrice(null);
    this.getTemplateViewModel().affiliateUrl(null);
    this.getTemplateViewModel().option(null);
    this.getTemplateViewModel().affiliateLinkTextOverride(null);
    this.getTemplateViewModel().affiliateExpirationOption(1);
    this.filterAffiliates.clearEverything();
    this.filterLocales.clearEverything();
  }

  protected shouldShowTagSpecDetails = (): boolean =>
    isSpecTypeIdWithRestrictions(
      this.getTemplateViewModel().selectedSpecType()
    );

  protected shouldShowPlainTextEntry = (): boolean => isSpecTypeIdPlainTextEntry(this.getTemplateViewModel().selectedSpecType());

  protected shouldShowImagesEntry = (): boolean => isSpecTypeIdImagesEntry(this.getTemplateViewModel().selectedSpecType());

  protected shouldShowListTagField = (): boolean => isSpecTypeIdListTag(this.getTemplateViewModel().selectedSpecType());

  protected onClickEditSpecification(data) {
    const vm = this.getTemplateViewModel();

    const specs = vm.specifications();

    let obj = specs.find(
      (spec) => spec.fieldId == data.fieldId && spec.label == data.label
    );

    if (!obj) {
      obj = data;
    }

    if (!vm.idBrand()) {
      obj.isDefault = true;
    }

    let selectedSpecType: dataType = vm
      .specTypes_options()
      .find(
        (specType) => specType.name.toLowerCase() == obj.dataType.toLowerCase()
      );
    if (selectedSpecType) {
      vm.selectedSpecType(selectedSpecType.id);
    }
    if (SPEC_TYPE_IDS_WITH_RESTRICTIONS.indexOf(selectedSpecType.id) > -1) {
      this.caller.getTagTypes(obj.typeRestrictions, "getTagTypes");
      this.caller.getTagTypes(obj.oldTypeRestrictions, "getOldTagTypes");
    }

    vm.isAddSpecVisible(true);
    vm.popupTitle("Edit Specification");
    vm.specEdited(data);
    vm.specificationLabel(obj.label);
    vm.specificationReference(obj.reference);
    vm.specificationExtra(obj.extraData);
    vm.useDefault(obj.isDefault ? obj.isDefault : false);

    vm.providerName(obj.providerName);

    if (vm.isBrandOwner()) {
      // useOverride keys on !isDefault for brand owner.
      vm.useOverride(!obj.isDefault);
    }

    if (selectedSpecType.id == SPEC_TYPE_TEXT.id) {
      vm.specificationData(obj.value);
      vm.specificationDefault(vm.getSpecDefault(obj));
    } else if (selectedSpecType.id == SPEC_TYPE_TAG.id) {
      vm.selectedTag(data.value);
      vm.defaultSelectedTag(vm.getRawSpecDefaultData(obj)[0]);
    } else if (selectedSpecType.id == SPEC_TYPE_TAGS.id) {
      vm.editedSelectedTags(data.value);
      vm.editedDefaultSelectedTags(vm.getRawSpecDefaultData(obj));
    } else if (selectedSpecType.id == SPEC_TYPE_DATE.id) {
      vm.dateSpec(data.value);
      vm.defaultDateSpec(vm.getSpecDefault(obj));
    } else if (selectedSpecType.id == SPEC_TYPE_RICH_TEXT.id) {
      vm.specificationData(obj.value);
      vm.specificationDefault(vm.getSpecDefault(obj));
      if (!vm.idBrand() || vm.isBrandOwner()) {
        this.caller.setTextAreaDefaultEditor(vm.getSpecDefault(obj));
      }
    } else if (SPEC_TYPE_IDS_NUMERIC.indexOf(selectedSpecType.id) > -1) {
      // currency, number and rating.
      vm.specificationData(obj.value);
      vm.specificationDefault(vm.getSpecDefault(obj));
    } else if (SPEC_TYPE_IMAGES.id == selectedSpecType.id) {
        if ((!vm.idBrand() || vm.isBrandOwner()) && obj.isDefault) {
            data = vm.getSpecDefaultData(obj.fieldId);
        }
        if (data &&data.value && Array.isArray(data.value)) {
            this.imageWidgetForTagImagesSpecField.setSelectedImages(data.value);
        }
    } else if (selectedSpecType.id == SPEC_TYPE_LIST_TAG.id) {
      // listTag is similar to tags but has no restrictions and is only editable at network/owner level
      vm.editedDefaultSelectedTags(vm.getRawSpecDefaultData(obj));
    }
    if (selectedSpecType.id == SPEC_TYPE_RATING.id) {
      vm.ratingScale(obj.ratingScale === null ? null : obj.ratingScale);

      if (!vm.idBrand() || vm.isBrandOwner()) {
        vm.defaultRatingScale(
          vm.specDefaults().find((def) => def.fieldId == obj.fieldId)
            .ratingScale
        );
      }
    }
    // this triggers the default value to show. If dependencies are set after this, that's a paddlin'.
    vm.idField(data ? data.fieldId : null);
  }

  protected formatNumberWithCommas(value) {
    // Remove any commas and dollar signs from the input
    if (value) {
      const cleanValueString = value
        .toString()
        .replace(/[$]/g, "")
        .replace(/,/g, "");
      const cleanValue = parseFloat(cleanValueString);
      const decimalPlaces = (cleanValue.toString().split(".")[1] || "").length;
      // Format the cleaned number with commas
      return cleanValue.toLocaleString(undefined, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      });
    }
  }

  protected onClickCancelSaveSpecification() {
    this.clearSpecEditForm();
  }

  protected onClickSaveSpecification() {
    let type = null;
    let data: any | null = null;
    let defaultData: any | null = null;
    let extraData: any | null = null;
    let defaultExtraData: any | null = null;
    let selectedSpecType = this.getTemplateViewModel()
      .specTypes_options()
      .find((e) => e.id == this.getTemplateViewModel().selectedSpecType());
    type = selectedSpecType.name.toLowerCase();

    if (this.getTemplateViewModel().selectedSpecType() == SPEC_TYPE_TEXT.id) {
      data = this.getTemplateViewModel().specificationData();
      defaultData = this.getTemplateViewModel().specificationDefault();
    } else if (
      this.getTemplateViewModel().selectedSpecType() == SPEC_TYPE_TAG.id
    ) {
      let tag: Tag = this.getTemplateViewModel().selectedTag();
      if (tag) {
        data = [tag];
      }
      let tagDefault: Tag = this.getTemplateViewModel().defaultSelectedTag();
      if (tagDefault) {
        defaultData = [tagDefault];
      }
    } else if (
      this.getTemplateViewModel().selectedSpecType() == SPEC_TYPE_TAGS.id
    ) {
      let values = [];
      if (this.getTemplateViewModel().editedSelectedTags()) {
        values = this.getTemplateViewModel().editedSelectedTags();
      }
      data = values;
      let defaultValues = [];
      if (this.getTemplateViewModel().editedDefaultSelectedTags()) {
        defaultValues = this.getTemplateViewModel().editedDefaultSelectedTags();
      }
      defaultData = defaultValues;
    } else if (
      this.getTemplateViewModel().selectedSpecType() == SPEC_TYPE_DATE.id
    ) {
      data = this.getTemplateViewModel().dateSpec();
      defaultData = this.getTemplateViewModel().defaultDateSpec();
    } else if (
      this.getTemplateViewModel().selectedSpecType() == SPEC_TYPE_RICH_TEXT.id
    ) {
      data = this.caller.getTextAreaEditor();
      if (
        this.getTemplateViewModel().isBrandOwner() ||
        !this.getTemplateViewModel().idBrand()
      ) {
        defaultData = this.caller.getTextAreaDefaultEditor();
      } else {
        defaultData = this.getTemplateViewModel().specificationDefault();
      }
    } else if (this.getTemplateViewModel().selectedSpecType() == SPEC_TYPE_IMAGES.id) {

        if ((!this.getTemplateViewModel().idBrand() || this.getTemplateViewModel().isBrandOwner()) && !this.getTemplateViewModel().useOverride()) {
            defaultData = this.imageWidgetForTagImagesSpecField.getSelectedImages();
        } else {
            data = this.imageWidgetForTagImagesSpecField.getSelectedImages();
        }
        this.imageWidgetForTagImagesSpecField.setSelectedImages([]);
    } else if (this.getTemplateViewModel().selectedSpecType() == SPEC_TYPE_LIST_TAG.id) {
      // listTag only supports default values (owner level) - no brand overrides
      let defaultValues = [];
      if (this.getTemplateViewModel().editedDefaultSelectedTags()) {
        defaultValues = this.getTemplateViewModel().editedDefaultSelectedTags();
      }
      data = defaultValues;
      defaultData = defaultValues;
    } else if (
      SPEC_TYPE_IDS_NUMERIC.indexOf(
        this.getTemplateViewModel().selectedSpecType()
      ) > -1
    ) {
      data = this.getTemplateViewModel().specificationData();
      defaultData = this.getTemplateViewModel().specificationDefault();
    }

    if (SPEC_TYPE_RATING.id == this.getTemplateViewModel().selectedSpecType()) {
      const ratingScale = this.getTemplateViewModel().ratingScale();
      this.getTemplateViewModel().specificationExtra({ ratingScale });
      extraData = this.getTemplateViewModel().specificationExtra();
      if (
        this.getTemplateViewModel().isBrandOwner() ||
        !this.getTemplateViewModel().idBrand()
      ) {
        const defaultRatingScale =
          this.getTemplateViewModel().defaultRatingScale();
        defaultExtraData = { ratingScale: defaultRatingScale };
      }
    }

    let restrictionsArray: number[] = [];
    if (this.getTemplateViewModel().restrictionTypeArray().length > 0) {
      this.getTemplateViewModel()
        .restrictionTypeArray()
        .forEach((e) => {
          restrictionsArray.push(e.id);
        });
    }

    let oldRestrictionsArray: number[] = [];
    if (this.getTemplateViewModel().oldRestrictionTypeArray().length > 0) {
      this.getTemplateViewModel()
        .oldRestrictionTypeArray()
        .forEach((e) => {
          oldRestrictionsArray.push(e.id);
        });
    }

    if (
      this.getTemplateViewModel().isBrandOwner() ||
      !this.getTemplateViewModel().idBrand()
    ) {
      // no override means keep the default as the value being used.
      if (!this.getTemplateViewModel().useOverride()) {
        // data = "";
        this.getTemplateViewModel().useDefault(true);
      } else {
        this.getTemplateViewModel().useDefault(false);
      }
    }

    if (this.getTemplateViewModel().selectedSpecType() == SPEC_TYPE_LIST_TAG.id) {
      this.getTemplateViewModel().useDefault(true);
    }

    let idField = null;
    if (this.getTemplateViewModel().specEdited()) {
      idField = this.getTemplateViewModel().specEdited().fieldId;
    }

      this.getTemplateViewModel().pendingSpecToAdd({
          fieldId: idField,
          isAdded: true,
          label: this.getTemplateViewModel().specificationLabel(),
          value: data,
          defaultValue: defaultData,
          extraData: extraData,
          defaultExtraData: defaultExtraData,
          isDefault: this.getTemplateViewModel().useDefault(),
          isProvider: this.isProviderField(idField, data),
          providerName: this.getProviderName(idField, data),
          dataType: type,
          canDelete: this.getTemplateViewModel().idField() ? false : true,
          typeRestrictions: restrictionsArray,
          oldTypeRestrictions: oldRestrictionsArray,
          isSelected: true,
          position: this.getTemplateViewModel().specifications().length + 1,
          reference: this.getTemplateViewModel().specificationReference(),
      });
    if (!this.getTemplateViewModel().idBrand()) {
      this.caller.validateTagSpec(
        idField,
        this.tagTypeFilter.getTemplateViewModel().idTagType,
        this.getTemplateViewModel().specificationLabel(),
        type,
        this.getTemplateViewModel().restrictionTypeArray(),
        this.getTemplateViewModel().oldRestrictionTypeArray()
      );
    } else {
      this.addSpecification();
    }
  }

  private getProviderName(fieldId: number, data: string): string {
    const vm = this.getTemplateViewModel();
    let providerName = null;
    let index = vm
    .specifications()
    .findIndex(
      (c) =>
        vm.specEdited() && c.fieldId == vm.specEdited().fieldId
    );
    if(index && vm.specifications()[index]) 
    {
      providerName = vm.specifications()[index].providerName;
    }
    return providerName;
  }
    

  private isProviderField(fieldId: number, data: string): boolean {

    const vm = this.getTemplateViewModel();
    let providerName = this.getProviderName(fieldId, data);
    let isProvider = false;
    // Test if the spec id related to a provider.
    if(providerName)
    {
      isProvider = true;
      const isChecked = vm.useOverride();
      if(isChecked){
        isProvider = false; 
      }
    }

    return isProvider;
  }

  public buildDatePickerCalendar() {
    this.linkExpirationDatePicker.buildCalendar();
  }

  private clearSpecEditForm() {
    this.evaluateShowAutoCalculateReviewScore();
    this.getTemplateViewModel().isAddSpecVisible(false);
    this.getTemplateViewModel().pendingSpecToAdd(null);
    this.getTemplateViewModel().selectedSpecType(null);
    this.getTemplateViewModel().specificationData(null);
    this.getTemplateViewModel().specificationLabel(null);
    this.getTemplateViewModel().specificationDefault(null);
    this.getTemplateViewModel().specificationExtra({ ratingScale: null });
    this.getTemplateViewModel().ratingScale(null);
    this.getTemplateViewModel().defaultRatingScale(null);
    this.getTemplateViewModel().tag_options([]);
    this.getTemplateViewModel().restrictionType(null);
    this.getTemplateViewModel().isAddSpecVisible(false);
    this.getTemplateViewModel().useDefault(null);
    this.getTemplateViewModel().useOverride(null);
    this.getTemplateViewModel().popupTitle(null);
    this.getTemplateViewModel().specificationIsForcedOverwrite(false);
    this.getTemplateViewModel().idField(null);
    this.getTemplateViewModel().editedSelectedTags(null);
    this.getTemplateViewModel().editedDefaultSelectedTags(null);
    this.getTemplateViewModel().specificationReference(null);
    this.getTemplateViewModel().specEdited(null);
    this.getTemplateViewModel().dateSpec(null);
    this.getTemplateViewModel().defaultDateSpec(null);
    this.restrictionFilter.clearEverything();
    this.getTemplateViewModel().restrictionTypeArray([]);
    this.getTemplateViewModel().oldRestrictionTypeArray([]);
    this.tagFilter.clearInput();
    this.defaultTagFilter.clearInput();
    this.imageWidgetForTagImagesSpecField.setSelectedImages([]);
  }

  public addSpecification() {
    const vm = this.getTemplateViewModel();
    let specs = vm.specifications();
    let specToAdd = vm.pendingSpecToAdd();

    // region defaults
    if (!vm.idBrand() || vm.isBrandOwner()) {
      const specDefaultToAdd = !!specToAdd.defaultExtraData
        ? { ...specToAdd, ...specToAdd.defaultExtraData }
        : { ...specToAdd };
      const defaultValue = specDefaultToAdd.defaultValue
        ? specDefaultToAdd.defaultValue
        : null;
      this.updateSpecDefault(specDefaultToAdd, defaultValue);
    }

    delete specToAdd.defaultExtraData;
    delete specToAdd.defaultValue;
    // endregion defaults

    if (!!specToAdd.extraData) {
      specToAdd = { ...specToAdd, ...specToAdd.extraData };
    }

    if (vm.specEdited()) {
      let index = vm
        .specifications()
        .findIndex(
          (c) =>
            c.fieldId == vm.specEdited().fieldId &&
            c.label == vm.specEdited().label
        );
      specs[index] = specToAdd;
    } else {
      specs.push(specToAdd);
    }

    vm.specifications([]);
    vm.specifications(specs);

    this.clearSpecEditForm();
  }

  protected updateSpecDefault(specToAdd, value: any): void {
    const specDefaults = this.getTemplateViewModel().specDefaults();

    // defaults come back with fieldId, not idField
    const defaultIndex = specToAdd.fieldId
      ? specDefaults.findIndex(
          (specDefault) => specToAdd.fieldId === specDefault.fieldId
        )
      : -1;

    if (defaultIndex < 0) {
      specToAdd.value = specToAdd.defaultValue;
      specDefaults.push(specToAdd);
    } else {
      if (specToAdd.defaultExtraData) {
        specDefaults[defaultIndex] = {
          ...specDefaults[defaultIndex],
          ...specToAdd.defaultExtraData,
        };
      } else {
        specDefaults[defaultIndex].ratingScale = null;
      }
      specDefaults[defaultIndex].value = value;
    }

    this.getTemplateViewModel().specDefaults([]);
    this.getTemplateViewModel().specDefaults(specDefaults);
  }

  public setId(id): void {
    this.getTemplateViewModel().id(id);
  }

  public setName(name): void {
    this.getTemplateViewModel().name(name);
  }

  public setIdReference(idReference): void {
    this.getTemplateViewModel().idReference(idReference);
  }

  public setReferenceDescription(referenceDescription): void {
    this.getTemplateViewModel().referenceDescription(referenceDescription);
  }

  public setReviewScore(reviewScore): void {
    this.getTemplateViewModel().reviewScore(reviewScore);
  }

  public setSlug(name): void {
    this.getTemplateViewModel().slug(name);
  }

  public setHasSlug(hasSlug): void {
    this.getTemplateViewModel().hasSlug(hasSlug);
  }

  public setUrlHubPage(url): void {
    this.getTemplateViewModel().urlHubPage(url);
  }

  public setTagType(tagType): void {
    this.getTemplateViewModel().tagType(tagType);
    this.tagTypeFilter.setTagTypeInfo(tagType);
  }

  public setIdTagType(idTagType): void {
    this.getTemplateViewModel().idTagType(idTagType);
  }

  public setTagDefaults(tagDefaults: any) {
    this.getTemplateViewModel().tagDefaults(tagDefaults);
  }

  public setTagColor(tagColor) {
    this.getTemplateViewModel().tagColor(tagColor);
  }

  public setDescription(description): void {
    this.getTemplateViewModel().description(description);
  }

  public setIdBrand(idBrand): void {
    this.getTemplateViewModel().idBrand(idBrand);
    this.getTemplateViewModel().brand(
      getBrandInfoFromVnAppZone(this.caller.getVnAppZone())
    );
  }

  public setIsTagSelectable(isTagSelectable): void {
    this.getTemplateViewModel().isTagSelectable(isTagSelectable);
  }

  public setIsTagActive(isTagActive): void {
    this.getTemplateViewModel().isTagActive(isTagActive);
  }

  public setProviders(providers): void {
    for (let provider of providers) {
      let description = provider["description"] || "";
      if (description != "") {
        this.addInfoButton(provider, provider["idProvider"], description);
      }
    }
    this.getTemplateViewModel().providers(providers);
  }

  protected handleSpecRatingScale = (specification) => {
    specification.oldTypeRestrictions = specification.typeRestrictions;
    specification.typeRestrictions = [];
    if (specification.dataType == "rating" && !specification.ratingScale) {
      specification.ratingScale = specification.extraData
        ? specification.extraData.ratingScale
        : null;
    }
    if (
      specification.dataType == "rating" &&
      specification.value != null &&
      specification.value != "" &&
      !this.getTemplateViewModel().showAutoCalculateReviewScore()
    ) {
      this.getTemplateViewModel().showAutoCalculateReviewScore(true);
    }

    return specification;
  };

  public setSpecifications(specifications): void {
    this.getTemplateViewModel().specifications(
      specifications.map(this.handleSpecRatingScale)
    );
  }

  public setSpecDefaults(specDefaults): void {
    this.getTemplateViewModel().specDefaults(
      specDefaults.map(this.handleSpecRatingScale)
    );
  }

  public setValidAutoPricingPartnerNames(validAutoPricingPartnerNames): void {
    this.getTemplateViewModel().validAutoPricingPartnerNames(
      validAutoPricingPartnerNames
    );
  }

  public setTagTypes(tagTypes): void {
    this.getTemplateViewModel().tagType_options(tagTypes);
  }

  public setTagOptions(tags): void {
    this.getTemplateViewModel().tag_options(tags);

    if (this.getTemplateViewModel().editedSelectedTags()) {
      if (this.getTemplateViewModel().editedSelectedTags().length == 1) {
        this.getTemplateViewModel().selectedTag(
          this.getTemplateViewModel().editedSelectedTags()[0]
        );
      } else {
        this.getTemplateViewModel().selectedTags(
          this.getTemplateViewModel().editedSelectedTags()
        );
      }
    }
  }

  protected onBlurTagType(data) {
    if (data.tagType()) {
      let selectedTagType = data
        .tagType_options()
        .find((c) => c.name.toLowerCase() === data.tagType().toLowerCase());
      if (selectedTagType) {
        let idType = selectedTagType.id;
        this.getTemplateViewModel().idTagType(idType);
        this.getTemplateViewModel().specifications(
          this.getSpecs(selectedTagType.fields, [])
        );
      }
    }
  }

  protected onBlurRestrictionType(data) {
    if (data.restrictionType()) {
      let selectedTagType = data
        .tagType_options()
        .find(
          (c) => c.name.toLowerCase() === data.restrictionType().toLowerCase()
        );
      if (selectedTagType) {
        let idType = selectedTagType.id;
        if (data.selectedSpecType() == 2 || data.selectedSpecType() == 3) {
          this.caller.getTagByType(idType);
        }
      }
    }
  }

  protected setTagTypeFilter(idElement, tagTypes): void {
    this.getTemplateViewModel()[idElement].tagTypes(tagTypes);
  }

  public onChangeSpecificationType() {
    this.getTemplateViewModel().specificationData("");
    if (
      this.getTemplateViewModel().selectedSpecType() == null ||
      this.getTemplateViewModel().selectedSpecType() == 1 ||
      this.getTemplateViewModel().selectedSpecType() == 4 ||
        this.getTemplateViewModel().selectedSpecType() == 9
    ) {
      this.getTemplateViewModel().tag_options([]);
      this.getTemplateViewModel().restrictionType("");
      this.restrictionFilter.clearInput();
    }
  }

  protected onClickDeleteSpecification(data) {
    let index = this.getTemplateViewModel()
      .specifications()
      .findIndex(
        (element) => element.label == data.label && element.data == data.data
      );
    if (index > -1) {
      this.getTemplateViewModel().specifications.splice(index, 1);
    }
  }

  private getSpecs(tagFields, values) {
    let specs: specification[] = [];

    for (let i = 0; i < tagFields.length; i++) {
      let dataType = tagFields[i].dataType;
      let fieldData = null;
      if (dataType == "text") {
        let fieldValue = values.find((o) => o.idField === tagFields[i].id);
        fieldData = fieldValue ? fieldValue.value : "";
      } else if (dataType == "tag") {
        let fieldValue = values.find((o) => o.idField === tagFields[i].id);
        fieldData = fieldValue ? fieldValue.value : {};
      } else if (dataType == "tags") {
        let fieldValue = values.filter((o) => o.idField === tagFields[i].id);
        fieldData = fieldValue ? fieldValue : [];
      } else if (dataType == "date") {
        let fieldValue = values.find((o) => o.idField === tagFields[i].id);
        fieldData = fieldValue ? fieldValue.value : "";
      } else if (dataType == "rich text") {
        let fieldValue = values.find((o) => o.idField === tagFields[i].id);
        fieldData = fieldValue ? fieldValue.value : "";
      }
      specs.push({
        fieldId: tagFields[i].id,
        label: tagFields[i].label,
        value: fieldData,
        typeRestrictions: tagFields[i].typeRestrictions,
        oldTypeRestrictions: tagFields[i].oldTypeRestrictions,
        dataType: dataType,
        isAdded: false,
        isForcedOverwrite: tagFields[i].isForcedOverwrite,
      });
    }

    return specs;
  }

  public showImagePicker(mode, target, selectedImages = []) {
    this.imagePicker.setMode(mode);
    this.imagePicker.setTarget(target);
    this.imagePicker.setSelectedImages(selectedImages);
    this.caller.getImageData();
    this.imagePicker.show();
  }

  public onClickRemoveSelectedTag(data) {
    let index = this.getTemplateViewModel()
      .editedSelectedTags()
      .findIndex((element) => element.id == data.id);
    if (index > -1) {
      let selectedTags = this.getTemplateViewModel().editedSelectedTags();
      selectedTags.splice(index, 1);
      this.getTemplateViewModel().editedSelectedTags([]);
      this.getTemplateViewModel().editedSelectedTags(selectedTags);
    }
  }

  public onClickRemoveDefaultSelectedTag(data) {
    let index = this.getTemplateViewModel()
      .editedDefaultSelectedTags()
      .findIndex((element) => element.id == data.id);
    if (index > -1) {
      let selectedTags =
        this.getTemplateViewModel().editedDefaultSelectedTags();
      selectedTags.splice(index, 1);
      this.getTemplateViewModel().editedDefaultSelectedTags([]);
      this.getTemplateViewModel().editedDefaultSelectedTags(selectedTags);
    }
  }

  public addTag() {
    let tagObj = this.tagFilter.getTemplateViewModel().tagObj();

    if (tagObj != "") {
      tagObj.type = {
        name: tagObj.tagType,
      };
      if (this.getTemplateViewModel().selectedSpecType() == 3) {
        let editedSelectedTags =
          this.getTemplateViewModel().editedSelectedTags()
            ? this.getTemplateViewModel().editedSelectedTags()
            : [];
        let index = editedSelectedTags.findIndex((el) => el.id == tagObj.id);
        if (index == -1) {
          editedSelectedTags.push(tagObj);
          this.getTemplateViewModel().editedSelectedTags([]);
          this.getTemplateViewModel().editedSelectedTags(editedSelectedTags);
          this.tagFilter.clearInput();
        }
      } else if (this.getTemplateViewModel().selectedSpecType() == 2) {
        this.getTemplateViewModel().selectedTag(tagObj);
      }
    }
  }

  public addTagDefault() {
    let tagObj = this.defaultTagFilter.getTemplateViewModel().tagObj();

    if (tagObj != "") {
      tagObj.type = {
        name: tagObj.tagType,
      };
      // Handle multi-select for tags and listTag
      if (this.getTemplateViewModel().selectedSpecType() == SPEC_TYPE_TAGS.id || this.getTemplateViewModel().selectedSpecType() == SPEC_TYPE_LIST_TAG.id) {
        let editedDefaultSelectedTags =
          this.getTemplateViewModel().editedDefaultSelectedTags()
            ? this.getTemplateViewModel().editedDefaultSelectedTags()
            : [];
        let index = editedDefaultSelectedTags.findIndex(
          (el) => el.id == tagObj.id
        );
        if (index == -1) {
          editedDefaultSelectedTags.push(tagObj);
          this.getTemplateViewModel().editedDefaultSelectedTags([]);
          this.getTemplateViewModel().editedDefaultSelectedTags(
            editedDefaultSelectedTags
          );
          this.defaultTagFilter.clearInput();
        }
      } else if (this.getTemplateViewModel().selectedSpecType() == 2) {
        this.getTemplateViewModel().defaultSelectedTag(tagObj);
      }
    }
  }

  public addTagType() {
    let tagTypeObj = this.tagTypeFilter.getTemplateViewModel().tagTypeObj();

    if (tagTypeObj != "") {
      this.getTemplateViewModel().tagType(tagTypeObj);
      this.getTemplateViewModel().specifications(
        this.getSpecs(tagTypeObj.fields, [])
      );
    } else {
      this.getTemplateViewModel().tagType(null);
      this.getTemplateViewModel().specifications([]);
    }
  }

  public sendTagFilterUpdates(tags) {
    // if the default filter's tag search is filled in, go with that one.
    if (this.defaultTagFilter.getTemplateViewModel().tag() !== "") {
      this.setDefaultTagFilter(tags);
    } else {
      this.setTagFilter(tags);
    }
  }

  public setTagFilter(tags) {
    this.tagFilter.getTemplateViewModel().tags(tags);
  }

  public setDefaultTagFilter(tags) {
    this.defaultTagFilter.getTemplateViewModel().tags(tags);
  }

  public getTagsSuggestion(keyword, idElement) {
    let tagTypesIds: number[] = [];
    if (this.getTemplateViewModel().restrictionTypeArray().length > 0) {
      this.getTemplateViewModel()
        .restrictionTypeArray()
        .forEach((e) => {
          tagTypesIds.push(e.id);
        });
    }
    if (this.getTemplateViewModel().oldRestrictionTypeArray().length > 0) {
      this.getTemplateViewModel()
        .oldRestrictionTypeArray()
        .forEach((e) => {
          tagTypesIds.push(e.id);
        });
    }

    this.caller.getTagByTypes(tagTypesIds, keyword);
  }

  public filterSimpleOnChange(idElement): void {
    if (idElement == "tagFilter") {
      this.addTag();
    } else if (idElement == "tagTypeFilter") {
      this.addTagType();
    } else if (idElement == "defaultTagFilter") {
      this.addTagDefault();
    }
  }

  public setPermissions(permissions) {
    this.getTemplateViewModel().permissions(permissions);
    this.videoPickerHelper.setPermissions(permissions);
  }

  public setSeoDescription(seoDescription) {
    this.getTemplateViewModel().seoDescription(seoDescription);
  }

  public setReviewText(reviewText) {
    const vm = this.getTemplateViewModel();

    vm.reviewText(reviewText);
  }

  public setAffiliateLinks(affiliateLinks) {
    //create datePicker and set expirationOption
    this.getTemplateViewModel().affiliateLinks(
      affiliateLinks === null ? null : [...affiliateLinks]
    );
  }

  private getFormattedEasternTimeZoneDateTime(delimiter): any {
    let date = this.createEasternTimeZoneDateTime();

    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minutes = date.getMinutes();

    return (
      year +
      delimiter +
      this.padInteger(month, 2) +
      delimiter +
      this.padInteger(day, 2) +
      " " +
      this.padInteger(hour, 2) +
      ":" +
      this.padInteger(minutes, 2)
    );
  }

  private padInteger(number: number, size: number) {
    let s = number + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  private createEasternTimeZoneDateTime(date?: Date): Date {
    if (!date) {
      date = new Date();
    }

    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    //checks if DST is currently being observed, adjusts offset accordingly
    let easternTimeOffset = this.isDstObserved(date) ? -240 : -300;
    date.setMinutes(date.getMinutes() + easternTimeOffset);

    return date;
  }

  public isDstObserved(date: Date) {
    let jan = new Date(date.getFullYear(), 0, 1);
    let jul = new Date(date.getFullYear(), 6, 1);
    let stdTimezoneOffset = Math.max(
      jan.getTimezoneOffset(),
      jul.getTimezoneOffset()
    );

    return date.getTimezoneOffset() < stdTimezoneOffset;
  }

  protected onClickAddAffiliateLink() {
    let defaultPlaceholder = "Affiliate Partner";
    let noPartnerSelected = "No Partner Selected";
    let alreadyAdded = "Affiliate Partner Already Added With The Same Url";
    let affiliateUrl = this.getTemplateViewModel().affiliateUrl();
    let affiliateAutomaticPricingAvailable = this.getTemplateViewModel().affiliateAutomaticPricingAvailable();
    let autoAffiliateEmakiAutolinker = this.getTemplateViewModel().autoAffiliateEmakiAutolinker();
    let autoAffiliateThirdPartyService = this.getTemplateViewModel().autoAffiliateThirdPartyService();
    let affiliateAutomaticPricing = this.getTemplateViewModel().affiliateAutomaticPricing();
    let affiliateSalePrice =
      this.getTemplateViewModel().affiliateSalePrice() &&
      !affiliateAutomaticPricing
        ? Math.round(this.getTemplateViewModel().affiliateSalePrice() * 100) /
          100
        : null;
    let affiliatePrice =
      this.getTemplateViewModel().affiliatePrice() && !affiliateAutomaticPricing
        ? Math.round(this.getTemplateViewModel().affiliatePrice() * 100) / 100
        : null;
    let affiliateLinkTextOverride =
      this.getTemplateViewModel().affiliateLinkTextOverride();
    let affiliateExpirationOption =
      this.getTemplateViewModel().affiliateExpirationOption();
    let affiliateExpirationDate =
      this.getTemplateViewModel().linkExpirationDatePicker.singleDatePicker();
    let linkIndex = this.getTemplateViewModel().linkIndex();

    let option = this.getTemplateViewModel().option();
    let geo = this.filterLocales.getTemplateViewModel().optionObj();

    let optionName = this.filterAffiliates
        .getTemplateViewModel()
        .newOptionName();

    if (!this.filterAffiliates.getTemplateViewModel().optionObj() && !optionName) {
      this.getTemplateViewModel().affiliateLinkError("Oops! It looks like you are missing the Affiliate Partner field.");
      return;
    }

    if (affiliateUrl === null) {
      this.getTemplateViewModel().affiliateLinkError("Oops! It looks like you are missing the URL field.");
      return;
    }

    if (this.getTemplateViewModel().isAffiliateLinksFormAdvancedVisible() && !option) {
      this.getTemplateViewModel().affiliateLinkError("Oops! It looks like you are missing the Option field.");
      return;
    }

    let dateExpiration = null;

    if (affiliateExpirationOption == 2) {
      //now
      dateExpiration = this.getFormattedEasternTimeZoneDateTime("-");
    } else if (affiliateExpirationOption == 3) {
      //scheduled
      dateExpiration = affiliateExpirationDate.replaceAll("/", "-");
    }

    let affiliateLinks = TagDefaultsHelper.getAffiliateLinks(
      this.getTemplateViewModel()
    );

    if (affiliateLinks === null) {
      affiliateLinks = [];
    }
    let highestId = 1;
    for (let a of affiliateLinks) {
      if (a.id > highestId) {
        highestId = a.id;
      }
    }
    if (this.filterAffiliates.getTemplateViewModel().addNewSelected()) {
      let optionName = this.filterAffiliates
        .getTemplateViewModel()
        .newOptionName();

      if (optionName != "") {
        this.filterAffiliates.setPlaceholder(defaultPlaceholder);
        if (affiliateUrl != null && affiliateUrl != "") {
          let newLink = {
            id: highestId + 1,
            automaticPricingAvailable: affiliateAutomaticPricingAvailable,
            autoAffiliateEmakiAutolinker: autoAffiliateEmakiAutolinker,
            autoAffiliateThirdPartyService: autoAffiliateThirdPartyService,
            automaticPricing: affiliateAutomaticPricing,
            salePrice: affiliateSalePrice,
            price: affiliatePrice,
            linkTextOverride: affiliateLinkTextOverride,
            type: optionName,
            value: affiliateUrl,
            expirationOption: affiliateExpirationOption,
            dateExpiration: dateExpiration,
            selected: false,
            isNew: true,
            idLocale: (geo == null || geo.id == null) ? null : geo.id,
            currency: (geo == null || geo.currency == null) ? null : geo.currency,
            locale: (geo == null || geo.fullLocale == null) ? null : geo.fullLocale,
            countryCode: (geo == null || geo.countryCode == null) ? null : geo.countryCode.toUpperCase(),
            option: (option == null || option == "") ? null : option,
          };

          if (linkIndex != null) {
            //preserve selection
            newLink.selected = affiliateLinks[linkIndex].selected;
            affiliateLinks[linkIndex] = newLink;
          } else {
            affiliateLinks.push(newLink);
          }

          this.filterAffiliates.clearEverything();
          this.getTemplateViewModel().affiliateLinkError(null);
          this.getTemplateViewModel().affiliateUrl(null);
          this.getTemplateViewModel().isAffiliateLinksFormShown(false);
          this.getTemplateViewModel().isAffiliateLinksFormAdvancedVisible(false);
        }
      } else {
        this.filterAffiliates.setPlaceholder(noPartnerSelected);
      }
    } else if (this.filterAffiliates.getTemplateViewModel().optionObj()) {
      let affiliate = this.filterAffiliates.getTemplateViewModel().optionObj();

      this.filterAffiliates.setPlaceholder(defaultPlaceholder);
      if (affiliateUrl != null && affiliateUrl != "") {
        let conflictedIndex: number | null = null;
        for (let i = 0; i < affiliateLinks.length; i++) {
          let tal = affiliateLinks[i];
          if (tal.type == affiliate.name && tal.value == affiliateUrl && this.verifyOptions(tal, {option})) {
            conflictedIndex = i;
            break;
          }
        }

        //Why new link? Why not grabe the existing and update it?
          let newLink = {
              id: affiliate.id,
              automaticPricingAvailable: affiliateAutomaticPricingAvailable,
              autoAffiliateEmakiAutolinker: autoAffiliateEmakiAutolinker,
              autoAffiliateThirdPartyService: autoAffiliateThirdPartyService,
              automaticPricing: affiliateAutomaticPricing,
              salePrice: affiliateSalePrice,
              price: affiliatePrice,
              linkTextOverride: affiliateLinkTextOverride,
              type: affiliate.name,
              value: affiliateUrl,
              expirationOption: affiliateExpirationOption,
              dateExpiration: dateExpiration,
              selected: false,
              isNew: false,
              idLocale: (geo == null || geo.id == null) ? null : geo.id,
              currency: (geo == null || geo.currency == null) ? null : geo.currency,
              locale: (geo == null || geo.fullLocale == null) ? null : geo.fullLocale,
              countryCode: (geo == null || geo.countryCode == null) ? null : geo.countryCode.toUpperCase(),
              option: (option == null || option == "") ? null : option,
          };

        let resetEverything = false;
        if (linkIndex != null) {
          if (conflictedIndex != null) {
            if (conflictedIndex == linkIndex) {
              newLink.selected = affiliateLinks[linkIndex].selected;
              affiliateLinks[linkIndex] = newLink;
              resetEverything = true;
            } else {
              this.filterAffiliates.setPlaceholder(alreadyAdded);
              this.getTemplateViewModel().affiliateLinkError(alreadyAdded);
            }
          } else {
            newLink.selected = affiliateLinks[linkIndex].selected;
            affiliateLinks[linkIndex] = newLink;
            resetEverything = true;
          }
        } else {
          if (conflictedIndex == null) {
            affiliateLinks.push(newLink);
            resetEverything = true;
          } else {
            this.filterAffiliates.setPlaceholder(alreadyAdded);
            this.getTemplateViewModel().affiliateLinkError(alreadyAdded);
          }
        }

        if (resetEverything == true) {
          this.filterAffiliates.clearEverything();
          this.getTemplateViewModel().affiliateLinkError(null);
          this.getTemplateViewModel().affiliateUrl(null);
          this.getTemplateViewModel().isAffiliateLinksFormShown(false);
          this.getTemplateViewModel().isAffiliateLinksFormAdvancedVisible(false);
        }
      }
    } else {
      this.filterAffiliates.setPlaceholder(noPartnerSelected);
    }

    TagDefaultsHelper.setAffiliateLinks(
      affiliateLinks,
      this.getTemplateViewModel()
    );

    this.getTemplateViewModel().affiliateOptionLinks(this.getTemplateViewModel().getAffiliateOptionsList());
    this.getTemplateViewModel().affiliateOptionsString(this.getTemplateViewModel().buildAffiliateOptionsString());
  }

  protected verifyOptions(linkObject1, linkObject2) {
    if ((linkObject1.option && linkObject2.option && linkObject1.option === linkObject2.option) ||
      ((!linkObject1.option || !linkObject2.option) && !(!linkObject1.option && !linkObject2.option))) {
      return true;
    }
    return false;
  }

  protected onClickDeleteAffiliateLinks(data, index) {
    let affiliateLinks = TagDefaultsHelper.getAffiliateLinks(
      this.getTemplateViewModel()
    );

    affiliateLinks.splice(index(), 1);

    TagDefaultsHelper.setAffiliateLinks(
      affiliateLinks,
      this.getTemplateViewModel()
    );
  }

  public removeValidationClass() {
    document.body.classList.remove("_form-sub");
  }

  protected onClickDeleteRestrictionTypeArray(data) {
    let selectedRestrictionTypeArray =
      this.getTemplateViewModel().restrictionTypeArray();
    let index = selectedRestrictionTypeArray.findIndex((i) => i.id == data.id);
    if (index != -1) {
      selectedRestrictionTypeArray.splice(index, 1);
    }

    this.getTemplateViewModel().restrictionTypeArray(
      selectedRestrictionTypeArray
    );
  }
  public addImage(target, viewMode, selectedImages) {
    this.showImagePicker(viewMode, target, selectedImages);
  }

  public viewImage(target) {
    let element = document.getElementById(target);
    element!.classList.add("is-viewing");
  }
  public editImage(target, viewMode, selectedImages) {
    this.showImagePicker(viewMode, target, selectedImages);
    let image = null;

    if (target == "tag_image") {
      image = this.imageWidgetForBrandTagImage.getImage();
    } else if (target == "default_tag_image") {
      image = this.imageWidgetForDefaultBrandTagImage.getImage();
    }

    this.imagePicker.editImage(image);
  }

  public closeImage(target) {
    let element = document.getElementById(target);
    element!.classList.remove("is-viewing");
  }

  public removeImage(target) {
    if (target == "tag_image") {
      this.imageWidgetForBrandTagImage.clearImage();
    } else if (target == "tag_image_group") {
      this.imageWidgetForBrandTagImageGroup.clearImage();
    } else if (target == "tag_image_icon") {
      this.imageWidgetForTagIconImage.clearImage();
    } else if (target == "tag_banner_image") {
      this.imageWidgetForTagBannerImage.clearImage();
    } else if (target == "default_tag_image") {
      this.imageWidgetForDefaultBrandTagImage.clearImage();
    } else if (target == "default_tag_image_group") {
      this.imageWidgetForDefaultBrandTagImageGroup.clearImage();
    } else if (target == "default_tag_image_icon") {
      this.imageWidgetForDefaultTagIconImage.clearImage();
    } else if (target == "default_tag_banner_image") {
      this.imageWidgetForDefaultTagBannerImage.clearImage();
    } else if (target == "video_thumbnail") {
      this.videoPickerHelper.clearThumbnailImage();
    }
  }

  public onClickAutoCalculateReviewScore(target) {
    let specs = this.getTemplateViewModel().specifications();
    let totalRating = 0,
      ratingsCount = 0,
      reviewScore = 0;

    specs.forEach((spec) => {
      if (
        spec.dataType == "rating" &&
        spec.ratingScale != null &&
        spec.value != null &&
        spec.value != ""
      ) {
        totalRating += spec.value / spec.ratingScale;
        ratingsCount++;
      }
    });

    if (ratingsCount > 0) {
      reviewScore = (totalRating / ratingsCount) * 10;
      if (!isNaN(reviewScore)) {
        reviewScore = parseFloat(reviewScore.toFixed(2));
      }
    }

    this.getTemplateViewModel().reviewScore(reviewScore);
  }

  public evaluateShowAutoCalculateReviewScore() {
    const specifications = this.getTemplateViewModel().specifications();
    const shouldShowAutoCalculate = specifications.some(
      (spec) =>
        spec.dataType === "rating" && spec.value !== null && spec.value !== ""
    );
    this.getTemplateViewModel().showAutoCalculateReviewScore(
      shouldShowAutoCalculate
    );
  }
  public setIsImageOptimized(val) {
    // TODO implement method when you delete an image through imagePickerHelper
  }

  // Adds info buttons.
  public addInfoButton(section, id, description) {
    section["infoButton"] = new infoButton_template(
      `infoButton_${id}`,
      this.getTemplateViewModel(),
      this.caller
    );
    section["infoButton"].setTitle("How to Get ID");
    section["infoButton"].setContent(`<p>${description}</p>`);
  }

    setReviewScoreEmbargoEndDate(date: string){
        this.reviewScoreEmbargoEndDate.setDate(date)
    }

    setReviewScoreIsUnderEmbargo(val: boolean){
        this.getTemplateViewModel().reviewScoreIsUnderEmbargo(val);
    }

    onChangeSetReviewScoreEmbargoEndDate(data, event){
      if(!this.getTemplateViewModel().reviewScoreIsUnderEmbargo()){
          this.reviewScoreEmbargoEndDate.setDate(null)
      }else{
          this.reviewScoreEmbargoEndDate.setDate(this.getFormattedEasternTimeZoneDateTime("/"))
      }
    }

    buildReviewScoreEmbargoEndDateCalendar(date){
        this.reviewScoreEmbargoEndDate.buildCalendar();
        this.reviewScoreEmbargoEndDate.setDate(date)
    }

    protected onClickActivateTag() {
      document.getElementById('inactive-tag-dialog-form').classList.toggle('loading');
      this.caller.activateTagById();
    }
  
    public toggleInactiveTagPopupVisibility() {
      document.getElementById('inactive-tag-dialog').classList.toggle('is-visible');
    }

    public  setIsAutoLinkerEnabled(isAutoLinkerEnabled) {
      this.getTemplateViewModel().isAutoLinkerEnabled(isAutoLinkerEnabled);
    }

    public  getIsAutoLinkerEnabled() {
        return this.getTemplateViewModel().isAutoLinkerEnabled();
    }

    public setIsAutoLinkerThirdPartyServiceEnabled(isAutoLinkerThirdPartyServiceEnabled) {
        this.getTemplateViewModel().isAutoLinkerThirdPartyServiceEnabled(isAutoLinkerThirdPartyServiceEnabled);
    }

    public getIsAutoLinkerThirdPartyServiceEnabled() {
        return this.getTemplateViewModel().isAutoLinkerThirdPartyServiceEnabled();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagsEdit_template.ts